//region block: polyfills
if (typeof Math.imul === 'undefined') {
  Math.imul = function imul(a, b) {
    return (a & 4.29490176E9) * (b & 65535) + (a & 65535) * (b | 0) | 0;
  };
}
if (typeof ArrayBuffer.isView === 'undefined') {
  ArrayBuffer.isView = function (a) {
    return a != null && a.__proto__ != null && a.__proto__.__proto__ === Int8Array.prototype.__proto__;
  };
}
if (typeof Array.prototype.fill === 'undefined') {
  // Polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill#Polyfill
  Object.defineProperty(Array.prototype, 'fill', {value: function (value) {
    // Steps 1-2.
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }
    var O = Object(this); // Steps 3-5.
    var len = O.length >>> 0; // Steps 6-7.
    var start = arguments[1];
    var relativeStart = start >> 0; // Step 8.
    var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len); // Steps 9-10.
    var end = arguments[2];
    var relativeEnd = end === undefined ? len : end >> 0; // Step 11.
    var finalValue = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len); // Step 12.
    while (k < finalValue) {
      O[k] = value;
      k++;
    }
    ; // Step 13.
    return O;
  }});
}
[Int8Array, Int16Array, Uint16Array, Int32Array, Float32Array, Float64Array].forEach(function (TypedArray) {
  if (typeof TypedArray.prototype.fill === 'undefined') {
    Object.defineProperty(TypedArray.prototype, 'fill', {value: Array.prototype.fill});
  }
});
if (typeof Math.clz32 === 'undefined') {
  Math.clz32 = function (log, LN2) {
    return function (x) {
      var asUint = x >>> 0;
      if (asUint === 0) {
        return 32;
      }
      return 31 - (log(asUint) / LN2 | 0) | 0; // the "| 0" acts like math.floor
    };
  }(Math.log, Math.LN2);
}
//endregion
(function (_) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var isView = ArrayBuffer.isView;
  var clz32 = Math.clz32;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(CharSequence, 'CharSequence');
  initMetadataForClass(Number_0, 'Number');
  initMetadataForClass(asSequence$$inlined$Sequence$1);
  initMetadataForClass(asSequence$$inlined$Sequence$1_0);
  initMetadataForClass(Char, 'Char');
  initMetadataForCompanion(Companion);
  initMetadataForInterface(Iterable, 'Iterable');
  initMetadataForInterface(Collection, 'Collection', VOID, VOID, [Iterable]);
  function asJsReadonlyArrayView() {
    return createJsReadonlyArrayViewFrom(this);
  }
  initMetadataForInterface(KtList, 'List', VOID, VOID, [Collection]);
  initMetadataForInterface(Entry, 'Entry');
  initMetadataForCompanion(Companion_0);
  function asJsReadonlyMapView() {
    return createJsReadonlyMapViewFrom(this);
  }
  initMetadataForInterface(KtMap, 'Map');
  initMetadataForCompanion(Companion_1);
  function asJsMapView() {
    return createJsMapViewFrom(this);
  }
  initMetadataForInterface(KtMutableMap, 'MutableMap', VOID, VOID, [KtMap]);
  initMetadataForInterface(KtSet, 'Set', VOID, VOID, [Collection]);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(Enum, 'Enum');
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(Long, 'Long', VOID, Number_0);
  initMetadataForClass(arrayIterator$1);
  initMetadataForClass(JsArrayView, 'JsArrayView', JsArrayView, Array);
  initMetadataForClass(JsMapView, 'JsMapView', JsMapView, Map);
  initMetadataForObject(Unit, 'Unit');
  initMetadataForClass(AbstractCollection, 'AbstractCollection', VOID, VOID, [Collection]);
  initMetadataForClass(AbstractMutableCollection, 'AbstractMutableCollection', VOID, AbstractCollection, [AbstractCollection, Collection, Iterable]);
  initMetadataForClass(IteratorImpl, 'IteratorImpl');
  initMetadataForClass(ListIteratorImpl, 'ListIteratorImpl', VOID, IteratorImpl);
  initMetadataForClass(AbstractMutableList, 'AbstractMutableList', VOID, AbstractMutableCollection, [AbstractMutableCollection, KtList, Iterable, Collection]);
  initMetadataForClass(SubList, 'SubList', VOID, AbstractMutableList);
  initMetadataForClass(AbstractMap, 'AbstractMap', VOID, VOID, [KtMap]);
  initMetadataForClass(AbstractMutableMap, 'AbstractMutableMap', VOID, AbstractMap, [AbstractMap, KtMutableMap]);
  initMetadataForClass(AbstractMutableSet, 'AbstractMutableSet', VOID, AbstractMutableCollection, [AbstractMutableCollection, Iterable, Collection, KtSet]);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(ArrayList, 'ArrayList', ArrayList_init_$Create$, AbstractMutableList, [AbstractMutableList, KtList, Iterable, Collection]);
  initMetadataForClass(HashMap, 'HashMap', HashMap_init_$Create$, AbstractMutableMap, [AbstractMutableMap, KtMutableMap]);
  initMetadataForClass(HashMapKeys, 'HashMapKeys', VOID, AbstractMutableSet, [Iterable, Collection, KtSet, AbstractMutableSet]);
  initMetadataForClass(HashMapValues, 'HashMapValues', VOID, AbstractMutableCollection, [Collection, Iterable, AbstractMutableCollection]);
  initMetadataForClass(HashMapEntrySetBase, 'HashMapEntrySetBase', VOID, AbstractMutableSet, [Iterable, Collection, KtSet, AbstractMutableSet]);
  initMetadataForClass(HashMapEntrySet, 'HashMapEntrySet', VOID, HashMapEntrySetBase);
  initMetadataForClass(HashMapKeysDefault$iterator$1);
  initMetadataForClass(HashMapKeysDefault, 'HashMapKeysDefault', VOID, AbstractMutableSet);
  initMetadataForClass(HashMapValuesDefault$iterator$1);
  initMetadataForClass(HashMapValuesDefault, 'HashMapValuesDefault', VOID, AbstractMutableCollection);
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(Itr, 'Itr');
  initMetadataForClass(KeysItr, 'KeysItr', VOID, Itr);
  initMetadataForClass(ValuesItr, 'ValuesItr', VOID, Itr);
  initMetadataForClass(EntriesItr, 'EntriesItr', VOID, Itr);
  initMetadataForClass(EntryRef, 'EntryRef', VOID, VOID, [Entry]);
  function containsAllEntries(m) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(m, Collection)) {
        tmp = m.h();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = m.c();
      while (_iterator__ex2g4s.d()) {
        var element = _iterator__ex2g4s.e();
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = element;
        var tmp_0;
        if (!(entry == null) ? isInterface(entry, Entry) : false) {
          tmp_0 = this.i6(entry);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  initMetadataForInterface(InternalMap, 'InternalMap');
  initMetadataForClass(InternalHashMap, 'InternalHashMap', InternalHashMap_init_$Create$, VOID, [InternalMap]);
  initMetadataForObject(EmptyHolder, 'EmptyHolder');
  initMetadataForClass(LinkedHashMap, 'LinkedHashMap', LinkedHashMap_init_$Create$, HashMap, [HashMap, KtMutableMap]);
  initMetadataForClass(Exception, 'Exception', Exception_init_$Create$, Error);
  initMetadataForClass(RuntimeException, 'RuntimeException', RuntimeException_init_$Create$, Exception);
  initMetadataForClass(IllegalArgumentException, 'IllegalArgumentException', IllegalArgumentException_init_$Create$, RuntimeException);
  initMetadataForClass(IllegalStateException, 'IllegalStateException', IllegalStateException_init_$Create$, RuntimeException);
  initMetadataForClass(UnsupportedOperationException, 'UnsupportedOperationException', UnsupportedOperationException_init_$Create$, RuntimeException);
  initMetadataForClass(NoSuchElementException, 'NoSuchElementException', NoSuchElementException_init_$Create$, RuntimeException);
  initMetadataForClass(IndexOutOfBoundsException, 'IndexOutOfBoundsException', IndexOutOfBoundsException_init_$Create$, RuntimeException);
  initMetadataForClass(ConcurrentModificationException, 'ConcurrentModificationException', ConcurrentModificationException_init_$Create$, RuntimeException);
  initMetadataForClass(NullPointerException, 'NullPointerException', NullPointerException_init_$Create$, RuntimeException);
  initMetadataForClass(ClassCastException, 'ClassCastException', ClassCastException_init_$Create$, RuntimeException);
  initMetadataForInterface(KClass, 'KClass');
  initMetadataForClass(KClassImpl, 'KClassImpl', VOID, VOID, [KClass]);
  initMetadataForObject(NothingKClassImpl, 'NothingKClassImpl', VOID, KClassImpl);
  initMetadataForClass(ErrorKClass, 'ErrorKClass', ErrorKClass, VOID, [KClass]);
  initMetadataForClass(PrimitiveKClassImpl, 'PrimitiveKClassImpl', VOID, KClassImpl);
  initMetadataForClass(SimpleKClassImpl, 'SimpleKClassImpl', VOID, KClassImpl);
  initMetadataForObject(PrimitiveClasses, 'PrimitiveClasses');
  initMetadataForClass(StringBuilder, 'StringBuilder', StringBuilder_init_$Create$_0, VOID, [CharSequence]);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(AbstractMap$keys$1$iterator$1);
  initMetadataForClass(AbstractMap$values$1$iterator$1);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(AbstractSet, 'AbstractSet', VOID, AbstractCollection, [AbstractCollection, KtSet]);
  initMetadataForClass(AbstractMap$keys$1, VOID, VOID, AbstractSet);
  initMetadataForClass(AbstractMap$values$1, VOID, VOID, AbstractCollection);
  initMetadataForCompanion(Companion_8);
  initMetadataForObject(EmptyList, 'EmptyList', VOID, VOID, [KtList]);
  initMetadataForObject(EmptyIterator, 'EmptyIterator');
  initMetadataForClass(ArrayAsCollection, 'ArrayAsCollection', VOID, VOID, [Collection]);
  initMetadataForObject(EmptyMap, 'EmptyMap', VOID, VOID, [KtMap]);
  initMetadataForClass(FlatteningSequence$iterator$1);
  initMetadataForClass(FlatteningSequence, 'FlatteningSequence');
  initMetadataForClass(TransformingSequence$iterator$1);
  initMetadataForClass(TransformingSequence, 'TransformingSequence');
  initMetadataForObject(EmptySequence, 'EmptySequence');
  initMetadataForObject(EmptySet, 'EmptySet', VOID, VOID, [KtSet]);
  initMetadataForClass(Pair, 'Pair');
  //endregion
  function CharSequence() {
  }
  function Number_0() {
  }
  function indexOf(_this__u8e3s4, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last = _this__u8e3s4.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this__u8e3s4[index] == null) {
            return index;
          }
        }
         while (inductionVariable <= last);
    } else {
      var inductionVariable_0 = 0;
      var last_0 = _this__u8e3s4.length - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals(element, _this__u8e3s4[index_0])) {
            return index_0;
          }
        }
         while (inductionVariable_0 <= last_0);
    }
    return -1;
  }
  function lastIndexOf(_this__u8e3s4, element) {
    if (element == null) {
      var inductionVariable = _this__u8e3s4.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (_this__u8e3s4[index] == null) {
            return index;
          }
        }
         while (0 <= inductionVariable);
    } else {
      var inductionVariable_0 = _this__u8e3s4.length - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          if (equals(element, _this__u8e3s4[index_0])) {
            return index_0;
          }
        }
         while (0 <= inductionVariable_0);
    }
    return -1;
  }
  function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    return joinTo(_this__u8e3s4, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    buffer.a(prefix);
    var count = 0;
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    $l$loop: while (inductionVariable < last) {
      var element = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.a(separator);
      }
      if (limit < 0 || count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$loop;
    }
    if (limit >= 0 && count > limit) {
      buffer.a(truncated);
    }
    buffer.a(postfix);
    return buffer;
  }
  function toList(_this__u8e3s4) {
    switch (_this__u8e3s4.length) {
      case 0:
        return emptyList();
      case 1:
        return listOf(_this__u8e3s4[0]);
      default:
        return toMutableList(_this__u8e3s4);
    }
  }
  function asSequence(_this__u8e3s4) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (_this__u8e3s4.length === 0)
      return emptySequence();
    // Inline function 'kotlin.sequences.Sequence' call
    return new asSequence$$inlined$Sequence$1(_this__u8e3s4);
  }
  function toMutableList(_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asCollection(_this__u8e3s4));
  }
  function asSequence$$inlined$Sequence$1($this_asSequence) {
    this.b_1 = $this_asSequence;
  }
  protoOf(asSequence$$inlined$Sequence$1).c = function () {
    return arrayIterator(this.b_1);
  };
  function joinToString_0(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    return joinTo_0(_this__u8e3s4, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinTo_0(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    buffer.a(prefix);
    var count = 0;
    var _iterator__ex2g4s = _this__u8e3s4.c();
    $l$loop: while (_iterator__ex2g4s.d()) {
      var element = _iterator__ex2g4s.e();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.a(separator);
      }
      if (limit < 0 || count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$loop;
    }
    if (limit >= 0 && count > limit) {
      buffer.a(truncated);
    }
    buffer.a(postfix);
    return buffer;
  }
  function asSequence_0(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.Sequence' call
    return new asSequence$$inlined$Sequence$1_0(_this__u8e3s4);
  }
  function asSequence$$inlined$Sequence$1_0($this_asSequence) {
    this.f_1 = $this_asSequence;
  }
  protoOf(asSequence$$inlined$Sequence$1_0).c = function () {
    return this.f_1.c();
  };
  function coerceAtLeast(_this__u8e3s4, minimumValue) {
    return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
  }
  function coerceAtMost(_this__u8e3s4, maximumValue) {
    return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
  }
  function flatMap(_this__u8e3s4, transform) {
    return new FlatteningSequence(_this__u8e3s4, transform, Sequence$iterator$ref());
  }
  function map(_this__u8e3s4, transform) {
    return new TransformingSequence(_this__u8e3s4, transform);
  }
  function Sequence$iterator$ref() {
    var l = function (p0) {
      return p0.c();
    };
    l.callableName = 'iterator';
    return l;
  }
  function _Char___init__impl__6a9atx(value) {
    return value;
  }
  function _get_value__a43j40($this) {
    return $this;
  }
  function toString($this) {
    // Inline function 'kotlin.js.unsafeCast' call
    return String.fromCharCode(_get_value__a43j40($this));
  }
  function Char() {
  }
  protoOf(Companion).fromJsArray = function (array) {
    return createListFrom(array);
  };
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function KtList() {
  }
  function Iterable() {
  }
  function Collection() {
  }
  function Entry() {
  }
  protoOf(Companion_0).fromJsMap = function (map) {
    return createMapFrom(map);
  };
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function KtMap() {
  }
  protoOf(Companion_1).fromJsMap = function (map) {
    return createMutableMapFrom(map);
  };
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function KtMutableMap() {
  }
  function KtSet() {
  }
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function Enum(name, ordinal) {
    this.c1_1 = name;
    this.d1_1 = ordinal;
  }
  protoOf(Enum).e1 = function () {
    return this.c1_1;
  };
  protoOf(Enum).f1 = function () {
    return this.d1_1;
  };
  protoOf(Enum).g1 = function (other) {
    return compareTo(this.d1_1, other.d1_1);
  };
  protoOf(Enum).h1 = function (other) {
    return this.g1(other instanceof Enum ? other : THROW_CCE());
  };
  protoOf(Enum).equals = function (other) {
    return this === other;
  };
  protoOf(Enum).hashCode = function () {
    return identityHashCode(this);
  };
  protoOf(Enum).toString = function () {
    return this.c1_1;
  };
  function toString_0(_this__u8e3s4) {
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function Companion_3() {
    Companion_instance_3 = this;
    this.i1_1 = new Long(0, -2147483648);
    this.j1_1 = new Long(-1, 2147483647);
    this.k1_1 = 8;
    this.l1_1 = 64;
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function Long(low, high) {
    Companion_getInstance_3();
    Number_0.call(this);
    this.m1_1 = low;
    this.n1_1 = high;
  }
  protoOf(Long).o1 = function (other) {
    return compare(this, other);
  };
  protoOf(Long).h1 = function (other) {
    return this.o1(other instanceof Long ? other : THROW_CCE());
  };
  protoOf(Long).p1 = function (other) {
    return add(this, other);
  };
  protoOf(Long).q1 = function (other) {
    return subtract(this, other);
  };
  protoOf(Long).r1 = function (other) {
    return multiply(this, other);
  };
  protoOf(Long).s1 = function (other) {
    return divide(this, other);
  };
  protoOf(Long).t1 = function () {
    return this.u1().p1(new Long(1, 0));
  };
  protoOf(Long).u1 = function () {
    return new Long(~this.m1_1, ~this.n1_1);
  };
  protoOf(Long).v1 = function () {
    return this.m1_1;
  };
  protoOf(Long).w1 = function () {
    return toNumber(this);
  };
  protoOf(Long).toString = function () {
    return toStringImpl(this, 10);
  };
  protoOf(Long).equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Long).hashCode = function () {
    return hashCode_0(this);
  };
  protoOf(Long).valueOf = function () {
    return this.w1();
  };
  function implement(interfaces) {
    var maxSize = 1;
    var masks = [];
    var inductionVariable = 0;
    var last = interfaces.length;
    while (inductionVariable < last) {
      var i = interfaces[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var currentSize = maxSize;
      var tmp0_elvis_lhs = i.prototype.$imask$;
      var imask = tmp0_elvis_lhs == null ? i.$imask$ : tmp0_elvis_lhs;
      if (!(imask == null)) {
        masks.push(imask);
        currentSize = imask.length;
      }
      var iid = i.$metadata$.iid;
      var tmp;
      if (iid == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = bitMaskWith(iid);
      }
      var iidImask = tmp;
      if (!(iidImask == null)) {
        masks.push(iidImask);
        currentSize = Math.max(currentSize, iidImask.length);
      }
      if (currentSize > maxSize) {
        maxSize = currentSize;
      }
    }
    return compositeBitMask(maxSize, masks);
  }
  function bitMaskWith(activeBit) {
    var numberIndex = activeBit >> 5;
    var intArray = new Int32Array(numberIndex + 1 | 0);
    var positionInNumber = activeBit & 31;
    var numberWithSettledBit = 1 << positionInNumber;
    intArray[numberIndex] = intArray[numberIndex] | numberWithSettledBit;
    return intArray;
  }
  function compositeBitMask(capacity, masks) {
    var tmp = 0;
    var tmp_0 = new Int32Array(capacity);
    while (tmp < capacity) {
      var tmp_1 = tmp;
      var result = 0;
      var inductionVariable = 0;
      var last = masks.length;
      while (inductionVariable < last) {
        var mask = masks[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (tmp_1 < mask.length) {
          result = result | mask[tmp_1];
        }
      }
      tmp_0[tmp_1] = result;
      tmp = tmp + 1 | 0;
    }
    return tmp_0;
  }
  function isBitSet(_this__u8e3s4, possibleActiveBit) {
    var numberIndex = possibleActiveBit >> 5;
    if (numberIndex > _this__u8e3s4.length)
      return false;
    var positionInNumber = possibleActiveBit & 31;
    var numberWithSettledBit = 1 << positionInNumber;
    return !((_this__u8e3s4[numberIndex] & numberWithSettledBit) === 0);
  }
  function arrayIterator(array) {
    return new arrayIterator$1(array);
  }
  function arrayIterator$1($array) {
    this.y1_1 = $array;
    this.x1_1 = 0;
  }
  protoOf(arrayIterator$1).d = function () {
    return !(this.x1_1 === this.y1_1.length);
  };
  protoOf(arrayIterator$1).e = function () {
    var tmp;
    if (!(this.x1_1 === this.y1_1.length)) {
      var _unary__edvuaz = this.x1_1;
      this.x1_1 = _unary__edvuaz + 1 | 0;
      tmp = this.y1_1[_unary__edvuaz];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this.x1_1);
    }
    return tmp;
  };
  function get_buf() {
    _init_properties_bitUtils_kt__nfcg4k();
    return buf;
  }
  var buf;
  function get_bufFloat64() {
    _init_properties_bitUtils_kt__nfcg4k();
    return bufFloat64;
  }
  var bufFloat64;
  var bufFloat32;
  function get_bufInt32() {
    _init_properties_bitUtils_kt__nfcg4k();
    return bufInt32;
  }
  var bufInt32;
  function get_lowIndex() {
    _init_properties_bitUtils_kt__nfcg4k();
    return lowIndex;
  }
  var lowIndex;
  function get_highIndex() {
    _init_properties_bitUtils_kt__nfcg4k();
    return highIndex;
  }
  var highIndex;
  function getNumberHashCode(obj) {
    _init_properties_bitUtils_kt__nfcg4k();
    // Inline function 'kotlin.js.jsBitwiseOr' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    if ((obj | 0) === obj) {
      return numberToInt(obj);
    }
    get_bufFloat64()[0] = obj;
    return imul(get_bufInt32()[get_highIndex()], 31) + get_bufInt32()[get_lowIndex()] | 0;
  }
  var properties_initialized_bitUtils_kt_i2bo3e;
  function _init_properties_bitUtils_kt__nfcg4k() {
    if (!properties_initialized_bitUtils_kt_i2bo3e) {
      properties_initialized_bitUtils_kt_i2bo3e = true;
      buf = new ArrayBuffer(8);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bufFloat64 = new Float64Array(get_buf());
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bufFloat32 = new Float32Array(get_buf());
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bufInt32 = new Int32Array(get_buf());
      // Inline function 'kotlin.run' call
      get_bufFloat64()[0] = -1.0;
      lowIndex = !(get_bufInt32()[0] === 0) ? 1 : 0;
      highIndex = 1 - get_lowIndex() | 0;
    }
  }
  function arrayToString(array) {
    return joinToString(array, ', ', '[', ']', VOID, VOID, arrayToString$lambda);
  }
  function arrayToString$lambda(it) {
    return toString_1(it);
  }
  function createJsReadonlyArrayViewFrom(list) {
    var tmp = createJsReadonlyArrayViewFrom$lambda(list);
    var tmp_0 = createJsReadonlyArrayViewFrom$lambda_0(list);
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = UNSUPPORTED_OPERATION$ref();
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_2 = UNSUPPORTED_OPERATION$ref_0();
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = UNSUPPORTED_OPERATION$ref_1();
    return createJsArrayViewWith(tmp, tmp_0, tmp_1, tmp_2, tmp$ret$2);
  }
  function createJsArrayViewWith(listSize, listGet, listSet, listDecreaseSize, listIncreaseSize) {
    var arrayView = new Array();
    var tmp = Object;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = JsArrayView;
    tmp.setPrototypeOf(arrayView, tmp$ret$0.prototype);
    return new Proxy(arrayView, {get: function (target, prop, receiver) {
      if (prop === 'length')
        return listSize();
      var type = typeof prop;
      var index = type === 'string' || type === 'number' ? +prop : undefined;
      if (!isNaN(index))
        return listGet(index);
      return target[prop];
    }, has: function (target, key) {
      return !isNaN(key) && key < listSize();
    }, set: function (obj, prop, value) {
      if (prop === 'length') {
        var size = listSize();
        var newSize = type === 'string' || type === 'number' ? +prop : undefined;
        if (isNaN(newSize))
          throw new RangeError('invalid array length');
        if (newSize < size)
          listDecreaseSize(size - newSize);
        else
          listIncreaseSize(newSize - size);
        return true;
      }
      var type = typeof prop;
      var index = type === 'string' || type === 'number' ? +prop : undefined;
      if (isNaN(index))
        return false;
      listSet(index, value);
      return true;
    }});
  }
  function UNSUPPORTED_OPERATION() {
    throw UnsupportedOperationException_init_$Create$();
  }
  function JsArrayView() {
    Array.call(this);
  }
  function createJsReadonlyMapViewFrom(map) {
    var tmp = createJsReadonlyMapViewFrom$lambda(map);
    var tmp_0 = createJsReadonlyMapViewFrom$lambda_0(map);
    var tmp_1 = createJsReadonlyMapViewFrom$lambda_1(map);
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_2 = UNSUPPORTED_OPERATION$ref_2();
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_3 = UNSUPPORTED_OPERATION$ref_3();
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_4 = UNSUPPORTED_OPERATION$ref_4();
    var tmp_5 = createJsReadonlyMapViewFrom$lambda_2(map);
    var tmp_6 = createJsReadonlyMapViewFrom$lambda_3(map);
    var tmp_7 = createJsReadonlyMapViewFrom$lambda_4(map);
    return createJsMapViewWith(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, createJsReadonlyMapViewFrom$lambda_5);
  }
  function createJsMapViewFrom(map) {
    var tmp = createJsMapViewFrom$lambda(map);
    var tmp_0 = createJsMapViewFrom$lambda_0(map);
    var tmp_1 = createJsMapViewFrom$lambda_1(map);
    var tmp_2 = createJsMapViewFrom$lambda_2(map);
    var tmp_3 = createJsMapViewFrom$lambda_3(map);
    var tmp_4 = createJsMapViewFrom$lambda_4(map);
    var tmp_5 = createJsMapViewFrom$lambda_5(map);
    var tmp_6 = createJsMapViewFrom$lambda_6(map);
    var tmp_7 = createJsMapViewFrom$lambda_7(map);
    return createJsMapViewWith(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, createJsMapViewFrom$lambda_8);
  }
  function createJsMapViewWith(mapSize, mapGet, mapContains, mapPut, mapRemove, mapClear, keysIterator, valuesIterator, entriesIterator, forEach) {
    // Inline function 'kotlin.also' call
    var this_0 = objectCreate(protoOf(JsMapView));
    this_0[Symbol.iterator] = entriesIterator;
    defineProp(this_0, 'size', mapSize, VOID);
    var mapView = this_0;
    return Object.assign(mapView, {get: mapGet, set: function (key, value) {
      mapPut(key, value);
      return this;
    }, 'delete': mapRemove, clear: mapClear, has: mapContains, keys: keysIterator, values: valuesIterator, entries: entriesIterator, forEach: function (cb, thisArg) {
      forEach(cb, mapView, thisArg);
    }});
  }
  function createJsIteratorFrom(iterator, transform) {
    var tmp;
    if (transform === VOID) {
      tmp = createJsIteratorFrom$lambda;
    } else {
      tmp = transform;
    }
    transform = tmp;
    var iteratorNext = createJsIteratorFrom$lambda_0(iterator);
    var iteratorHasNext = createJsIteratorFrom$lambda_1(iterator);
    var jsIterator = {next: function () {
      var result = {done: !iteratorHasNext()};
      if (!result.done)
        result.value = transform(iteratorNext());
      return result;
    }};
    jsIterator[Symbol.iterator] = function () {
      return this;
    };
    return jsIterator;
  }
  function forEach(cb, collection, thisArg) {
    thisArg = thisArg === VOID ? undefined : thisArg;
    var iterator = collection.entries();
    var result = iterator.next();
    while (!result.done) {
      var value = result.value;
      // Inline function 'kotlin.js.asDynamic' call
      cb.call(thisArg, value[1], value[0], collection);
      result = iterator.next();
    }
  }
  function JsMapView() {
    Map.call(this);
  }
  function createListFrom(array) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$1 = array.slice();
    return (new ArrayList(tmp$ret$1)).c2();
  }
  function createMapFrom(map) {
    // Inline function 'kotlin.collections.buildMapInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$();
    forEach(createMapFrom$lambda(this_0), map);
    return this_0.c2();
  }
  function createMutableMapFrom(map) {
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$();
    forEach(createMutableMapFrom$lambda(this_0), map);
    return this_0;
  }
  function createJsReadonlyArrayViewFrom$lambda($list) {
    return function () {
      return $list.g();
    };
  }
  function createJsReadonlyArrayViewFrom$lambda_0($list) {
    return function (i) {
      return $list.k(i);
    };
  }
  function UNSUPPORTED_OPERATION$ref() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function UNSUPPORTED_OPERATION$ref_0() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function UNSUPPORTED_OPERATION$ref_1() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function createJsReadonlyMapViewFrom$lambda($map) {
    return function () {
      return $map.g();
    };
  }
  function createJsReadonlyMapViewFrom$lambda_0($map) {
    return function (k) {
      return $map.u(k);
    };
  }
  function createJsReadonlyMapViewFrom$lambda_1($map) {
    return function (k) {
      return $map.s(k);
    };
  }
  function UNSUPPORTED_OPERATION$ref_2() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function UNSUPPORTED_OPERATION$ref_3() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function UNSUPPORTED_OPERATION$ref_4() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function createJsReadonlyMapViewFrom$lambda_2($map) {
    return function () {
      return createJsIteratorFrom($map.v().c());
    };
  }
  function createJsReadonlyMapViewFrom$lambda_3($map) {
    return function () {
      return createJsIteratorFrom($map.w().c());
    };
  }
  function createJsReadonlyMapViewFrom$lambda$lambda(it) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [it.q(), it.r()];
  }
  function createJsReadonlyMapViewFrom$lambda_4($map) {
    return function () {
      var tmp = $map.x().c();
      return createJsIteratorFrom(tmp, createJsReadonlyMapViewFrom$lambda$lambda);
    };
  }
  function createJsReadonlyMapViewFrom$lambda_5(callback, map, thisArg) {
    forEach(callback, map, thisArg);
    return Unit_instance;
  }
  function createJsMapViewFrom$lambda($map) {
    return function () {
      return $map.g();
    };
  }
  function createJsMapViewFrom$lambda_0($map) {
    return function (k) {
      return $map.u(k);
    };
  }
  function createJsMapViewFrom$lambda_1($map) {
    return function (k) {
      return $map.s(k);
    };
  }
  function createJsMapViewFrom$lambda_2($map) {
    return function (k, v) {
      $map.y(k, v);
      return Unit_instance;
    };
  }
  function createJsMapViewFrom$lambda_3($map) {
    return function (k) {
      $map.z(k);
      return Unit_instance;
    };
  }
  function createJsMapViewFrom$lambda_4($map) {
    return function () {
      $map.b1();
      return Unit_instance;
    };
  }
  function createJsMapViewFrom$lambda_5($map) {
    return function () {
      return createJsIteratorFrom($map.v().c());
    };
  }
  function createJsMapViewFrom$lambda_6($map) {
    return function () {
      return createJsIteratorFrom($map.w().c());
    };
  }
  function createJsMapViewFrom$lambda$lambda(it) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [it.q(), it.r()];
  }
  function createJsMapViewFrom$lambda_7($map) {
    return function () {
      var tmp = $map.x().c();
      return createJsIteratorFrom(tmp, createJsMapViewFrom$lambda$lambda);
    };
  }
  function createJsMapViewFrom$lambda_8(callback, map, thisArg) {
    forEach(callback, map, thisArg);
    return Unit_instance;
  }
  function createJsIteratorFrom$lambda(it) {
    return it;
  }
  function createJsIteratorFrom$lambda_0($iterator) {
    return function () {
      return $iterator.e();
    };
  }
  function createJsIteratorFrom$lambda_1($iterator) {
    return function () {
      return $iterator.d();
    };
  }
  function createMapFrom$lambda($$this$buildMapInternal) {
    return function (value, key, _unused_var__etf5q3) {
      $$this$buildMapInternal.y(key, value);
      return Unit_instance;
    };
  }
  function createMutableMapFrom$lambda($$this$apply) {
    return function (value, key, _unused_var__etf5q3) {
      $$this$apply.y(key, value);
      return Unit_instance;
    };
  }
  function compareTo(a, b) {
    var tmp;
    switch (typeof a) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.w1());
          } else {
            tmp_0 = primitiveCompareTo(a, b);
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:
        tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var ia = 1 / a;
        var tmp_1;
        // Inline function 'kotlin.js.asDynamic' call
        if (ia === 1 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            tmp_1 = 1;
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.h1(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    // Inline function 'kotlin.js.jsIn' call
    if (!('kotlinHashCodeValue$' in obj)) {
      var hash = calculateRandomHash();
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return obj['kotlinHashCodeValue$'];
  }
  function calculateRandomHash() {
    // Inline function 'kotlin.js.jsBitwiseOr' call
    return Math.random() * 4.294967296E9 | 0;
  }
  function defineProp(obj, name, getter, setter) {
    return Object.defineProperty(obj, name, {configurable: true, get: getter, set: setter});
  }
  function objectCreate(proto) {
    proto = proto === VOID ? null : proto;
    return Object.create(proto);
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else if (!(typeof o.toString === 'function')) {
      tmp = anyToString(o);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = o.toString();
    }
    return tmp;
  }
  function anyToString(o) {
    return Object.prototype.toString.call(o);
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var typeOf = typeof obj;
    var tmp;
    switch (typeOf) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        // Inline function 'kotlin.js.unsafeCast' call

        tmp = getBooleanHashCode(obj);
        break;
      case 'string':
        tmp = getStringHashCode(String(obj));
        break;
      case 'bigint':
        tmp = getBigIntHashCode(obj);
        break;
      case 'symbol':
        tmp = getSymbolHashCode(obj);
        break;
      default:
        tmp = function () {
          throw new Error('Unexpected typeof `' + typeOf + '`');
        }();
        break;
    }
    return tmp;
  }
  function getBooleanHashCode(value) {
    return value ? 1231 : 1237;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last = length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last));
    return hash;
  }
  function getBigIntHashCode(value) {
    var shiftNumber = BigInt(32);
    var MASK = BigInt(4.294967295E9);
    var bigNumber = value < 0 ? -value : value;
    var hashCode = 0;
    var signum = value < 0 ? -1 : 1;
    while (bigNumber != 0) {
      // Inline function 'kotlin.js.unsafeCast' call
      var chunk = Number(bigNumber & MASK);
      hashCode = imul(31, hashCode) + chunk | 0;
      bigNumber = bigNumber >> shiftNumber;
    }
    return imul(hashCode, signum);
  }
  function getSymbolHashCode(value) {
    var hashCodeMap = symbolIsSharable(value) ? getSymbolMap() : getSymbolWeakMap();
    var cachedHashCode = hashCodeMap.get(value);
    if (cachedHashCode !== VOID)
      return cachedHashCode;
    var hash = calculateRandomHash();
    hashCodeMap.set(value, hash);
    return hash;
  }
  function symbolIsSharable(symbol) {
    return Symbol.keyFor(symbol) != VOID;
  }
  function getSymbolMap() {
    if (symbolMap === VOID) {
      symbolMap = new Map();
    }
    return symbolMap;
  }
  function getSymbolWeakMap() {
    if (symbolWeakMap === VOID) {
      symbolWeakMap = new WeakMap();
    }
    return symbolWeakMap;
  }
  var symbolMap;
  var symbolWeakMap;
  function equals(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }
    if (obj2 == null) {
      return false;
    }
    if (typeof obj1 === 'object' && typeof obj1.equals === 'function') {
      return obj1.equals(obj2);
    }
    if (obj1 !== obj1) {
      return obj2 !== obj2;
    }
    if (typeof obj1 === 'number' && typeof obj2 === 'number') {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_1 = 1 / obj1;
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = tmp_1 === 1 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }
    return obj1 === obj2;
  }
  function unboxIntrinsic(x) {
    var message = 'Should be lowered';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      instance.stack = (new Error()).stack;
    }
  }
  function protoOf(constructor) {
    return constructor.prototype;
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    var errorInfo = calculateErrorInfo(Object.getPrototypeOf(this_));
    if ((errorInfo & 1) === 0) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp1_elvis_lhs = cause == null ? null : cause.toString();
          tmp_0 = tmp1_elvis_lhs == null ? VOID : tmp1_elvis_lhs;
        } else {
          tmp_0 = VOID;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }
    if ((errorInfo & 2) === 0) {
      this_.cause = cause;
    }
    this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function THROW_IAE(msg) {
    throw IllegalArgumentException_init_$Create$_0(msg);
  }
  function get_ZERO() {
    _init_properties_longJs_kt__elc2w5();
    return ZERO;
  }
  var ZERO;
  function get_ONE() {
    _init_properties_longJs_kt__elc2w5();
    return ONE;
  }
  var ONE;
  function get_NEG_ONE() {
    _init_properties_longJs_kt__elc2w5();
    return NEG_ONE;
  }
  var NEG_ONE;
  function get_MAX_VALUE() {
    _init_properties_longJs_kt__elc2w5();
    return MAX_VALUE;
  }
  var MAX_VALUE;
  function get_MIN_VALUE() {
    _init_properties_longJs_kt__elc2w5();
    return MIN_VALUE;
  }
  var MIN_VALUE;
  function get_TWO_PWR_24_() {
    _init_properties_longJs_kt__elc2w5();
    return TWO_PWR_24_;
  }
  var TWO_PWR_24_;
  function compare(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    if (equalsLong(_this__u8e3s4, other)) {
      return 0;
    }
    var thisNeg = isNegative(_this__u8e3s4);
    var otherNeg = isNegative(other);
    return thisNeg && !otherNeg ? -1 : !thisNeg && otherNeg ? 1 : isNegative(subtract(_this__u8e3s4, other)) ? -1 : 1;
  }
  function add(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    var a48 = _this__u8e3s4.n1_1 >>> 16 | 0;
    var a32 = _this__u8e3s4.n1_1 & 65535;
    var a16 = _this__u8e3s4.m1_1 >>> 16 | 0;
    var a00 = _this__u8e3s4.m1_1 & 65535;
    var b48 = other.n1_1 >>> 16 | 0;
    var b32 = other.n1_1 & 65535;
    var b16 = other.m1_1 >>> 16 | 0;
    var b00 = other.m1_1 & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return add(_this__u8e3s4, other.t1());
  }
  function multiply(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    if (isZero(_this__u8e3s4)) {
      return get_ZERO();
    } else if (isZero(other)) {
      return get_ZERO();
    }
    if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
      return isOdd(other) ? get_MIN_VALUE() : get_ZERO();
    } else if (equalsLong(other, get_MIN_VALUE())) {
      return isOdd(_this__u8e3s4) ? get_MIN_VALUE() : get_ZERO();
    }
    if (isNegative(_this__u8e3s4)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this__u8e3s4), negate(other));
      } else {
        tmp = negate(multiply(negate(_this__u8e3s4), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this__u8e3s4, negate(other)));
    }
    if (lessThan(_this__u8e3s4, get_TWO_PWR_24_()) && lessThan(other, get_TWO_PWR_24_())) {
      return fromNumber(toNumber(_this__u8e3s4) * toNumber(other));
    }
    var a48 = _this__u8e3s4.n1_1 >>> 16 | 0;
    var a32 = _this__u8e3s4.n1_1 & 65535;
    var a16 = _this__u8e3s4.m1_1 >>> 16 | 0;
    var a00 = _this__u8e3s4.m1_1 & 65535;
    var b48 = other.n1_1 >>> 16 | 0;
    var b32 = other.n1_1 & 65535;
    var b16 = other.m1_1 >>> 16 | 0;
    var b00 = other.m1_1 & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    if (isZero(other)) {
      throw Exception_init_$Create$_0('division by zero');
    } else if (isZero(_this__u8e3s4)) {
      return get_ZERO();
    }
    if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
      if (equalsLong(other, get_ONE()) || equalsLong(other, get_NEG_ONE())) {
        return get_MIN_VALUE();
      } else if (equalsLong(other, get_MIN_VALUE())) {
        return get_ONE();
      } else {
        var halfThis = shiftRight(_this__u8e3s4, 1);
        var approx = shiftLeft(halfThis.s1(other), 1);
        if (equalsLong(approx, get_ZERO())) {
          return isNegative(other) ? get_ONE() : get_NEG_ONE();
        } else {
          var rem = subtract(_this__u8e3s4, multiply(other, approx));
          return add(approx, rem.s1(other));
        }
      }
    } else if (equalsLong(other, get_MIN_VALUE())) {
      return get_ZERO();
    }
    if (isNegative(_this__u8e3s4)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this__u8e3s4).s1(negate(other));
      } else {
        tmp = negate(negate(_this__u8e3s4).s1(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this__u8e3s4.s1(negate(other)));
    }
    var res = get_ZERO();
    var rem_0 = _this__u8e3s4;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta = log2 <= 48 ? 1.0 : Math.pow(2.0, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) || greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = get_ONE();
      }
      res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function shiftLeft(_this__u8e3s4, numBits) {
    _init_properties_longJs_kt__elc2w5();
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this__u8e3s4;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this__u8e3s4.m1_1 << numBits_0, _this__u8e3s4.n1_1 << numBits_0 | (_this__u8e3s4.m1_1 >>> (32 - numBits_0 | 0) | 0));
      } else {
        return new Long(0, _this__u8e3s4.m1_1 << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this__u8e3s4, numBits) {
    _init_properties_longJs_kt__elc2w5();
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this__u8e3s4;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this__u8e3s4.m1_1 >>> numBits_0 | 0 | _this__u8e3s4.n1_1 << (32 - numBits_0 | 0), _this__u8e3s4.n1_1 >> numBits_0);
      } else {
        return new Long(_this__u8e3s4.n1_1 >> (numBits_0 - 32 | 0), _this__u8e3s4.n1_1 >= 0 ? 0 : -1);
      }
    }
  }
  function toNumber(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.n1_1 * 4.294967296E9 + getLowBitsUnsigned(_this__u8e3s4);
  }
  function toStringImpl(_this__u8e3s4, radix) {
    _init_properties_longJs_kt__elc2w5();
    if (radix < 2 || 36 < radix) {
      throw Exception_init_$Create$_0('radix out of range: ' + radix);
    }
    if (isZero(_this__u8e3s4)) {
      return '0';
    }
    if (isNegative(_this__u8e3s4)) {
      if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
        var radixLong = fromInt(radix);
        var div = _this__u8e3s4.s1(radixLong);
        var rem = subtract(multiply(div, radixLong), _this__u8e3s4).v1();
        var tmp = toStringImpl(div, radix);
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        return tmp + rem.toString(radix);
      } else {
        return '-' + toStringImpl(negate(_this__u8e3s4), radix);
      }
    }
    var digitsPerTime = radix === 2 ? 31 : radix <= 10 ? 9 : radix <= 21 ? 7 : radix <= 35 ? 6 : 5;
    var radixToPower = fromNumber(Math.pow(radix, digitsPerTime));
    var rem_0 = _this__u8e3s4;
    var result = '';
    while (true) {
      var remDiv = rem_0.s1(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).v1();
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var digits = intval.toString(radix);
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < digitsPerTime) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function equalsLong(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.n1_1 === other.n1_1 && _this__u8e3s4.m1_1 === other.m1_1;
  }
  function hashCode_0(l) {
    _init_properties_longJs_kt__elc2w5();
    return l.m1_1 ^ l.n1_1;
  }
  function fromInt(value) {
    _init_properties_longJs_kt__elc2w5();
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.n1_1 < 0;
  }
  function isZero(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.n1_1 === 0 && _this__u8e3s4.m1_1 === 0;
  }
  function isOdd(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return (_this__u8e3s4.m1_1 & 1) === 1;
  }
  function negate(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.t1();
  }
  function lessThan(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return compare(_this__u8e3s4, other) < 0;
  }
  function fromNumber(value) {
    _init_properties_longJs_kt__elc2w5();
    if (isNaN_0(value)) {
      return get_ZERO();
    } else if (value <= -9.223372036854776E18) {
      return get_MIN_VALUE();
    } else if (value + 1 >= 9.223372036854776E18) {
      return get_MAX_VALUE();
    } else if (value < 0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      // Inline function 'kotlin.js.jsBitwiseOr' call
      var tmp = value % twoPwr32 | 0;
      // Inline function 'kotlin.js.jsBitwiseOr' call
      var tmp$ret$1 = value / twoPwr32 | 0;
      return new Long(tmp, tmp$ret$1);
    }
  }
  function greaterThan(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return compare(_this__u8e3s4, other) > 0;
  }
  function greaterThanOrEqual(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return compare(_this__u8e3s4, other) >= 0;
  }
  function getLowBitsUnsigned(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.m1_1 >= 0 ? _this__u8e3s4.m1_1 : 4.294967296E9 + _this__u8e3s4.m1_1;
  }
  var properties_initialized_longJs_kt_4syf89;
  function _init_properties_longJs_kt__elc2w5() {
    if (!properties_initialized_longJs_kt_4syf89) {
      properties_initialized_longJs_kt_4syf89 = true;
      ZERO = fromInt(0);
      ONE = fromInt(1);
      NEG_ONE = fromInt(-1);
      MAX_VALUE = new Long(-1, 2147483647);
      MIN_VALUE = new Long(0, -2147483648);
      TWO_PWR_24_ = fromInt(16777216);
    }
  }
  function createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
    var undef = VOID;
    var iid = kind === 'interface' ? generateInterfaceId() : VOID;
    return {kind: kind, simpleName: name, associatedObjectKey: associatedObjectKey, associatedObjects: associatedObjects, suspendArity: suspendArity, $kClass$: undef, defaultConstructor: defaultConstructor, iid: iid};
  }
  function generateInterfaceId() {
    if (globalInterfaceId === VOID) {
      globalInterfaceId = 0;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    globalInterfaceId = globalInterfaceId + 1 | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    return globalInterfaceId;
  }
  var globalInterfaceId;
  function initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    if (!(parent == null)) {
      ctor.prototype = Object.create(parent.prototype);
      ctor.prototype.constructor = ctor;
    }
    var metadata = createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity);
    ctor.$metadata$ = metadata;
    if (!(interfaces == null)) {
      var receiver = !equals(metadata.iid, VOID) ? ctor : ctor.prototype;
      receiver.$imask$ = implement(interfaces);
    }
  }
  function initMetadataForClass(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    var kind = 'class';
    initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
  }
  function initMetadataForObject(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    var kind = 'object';
    initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
  }
  function initMetadataForInterface(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    var kind = 'interface';
    initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
  }
  function initMetadataForLambda(ctor, parent, interfaces, suspendArity) {
    initMetadataForClass(ctor, 'Lambda', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function initMetadataForCoroutine(ctor, parent, interfaces, suspendArity) {
    initMetadataForClass(ctor, 'Coroutine', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function initMetadataForFunctionReference(ctor, parent, interfaces, suspendArity) {
    initMetadataForClass(ctor, 'FunctionReference', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function initMetadataForCompanion(ctor, parent, interfaces, suspendArity) {
    initMetadataForObject(ctor, 'Companion', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.v1();
    } else {
      tmp = doubleToInt(a);
    }
    return tmp;
  }
  function doubleToInt(a) {
    var tmp;
    if (a > 2147483647) {
      tmp = 2147483647;
    } else if (a < -2147483648) {
      tmp = -2147483648;
    } else {
      // Inline function 'kotlin.js.jsBitwiseOr' call
      tmp = a | 0;
    }
    return tmp;
  }
  function numberToDouble(a) {
    // Inline function 'kotlin.js.unsafeCast' call
    return +a;
  }
  function numberToLong(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a;
    } else {
      tmp = fromNumber(a);
    }
    return tmp;
  }
  function toLong(a) {
    return fromInt(a);
  }
  function isArrayish(o) {
    return isJsArray(o) || isView(o);
  }
  function isJsArray(obj) {
    // Inline function 'kotlin.js.unsafeCast' call
    return Array.isArray(obj);
  }
  function isInterface(obj, iface) {
    return isInterfaceImpl(obj, iface.$metadata$.iid);
  }
  function isInterfaceImpl(obj, iface) {
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_elvis_lhs = obj.$imask$;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var mask = tmp;
    return isBitSet(mask, iface);
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isCharSequence(value) {
    return typeof value === 'string' || isInterface(value, CharSequence);
  }
  function isBooleanArray(a) {
    return isJsArray(a) && a.$type$ === 'BooleanArray';
  }
  function isByteArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Int8Array;
  }
  function isShortArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Int16Array;
  }
  function isCharArray(a) {
    var tmp;
    // Inline function 'kotlin.js.jsInstanceOf' call
    if (a instanceof Uint16Array) {
      tmp = a.$type$ === 'CharArray';
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isIntArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Int32Array;
  }
  function isFloatArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Float32Array;
  }
  function isLongArray(a) {
    return isJsArray(a) && a.$type$ === 'LongArray';
  }
  function isDoubleArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Float64Array;
  }
  function calculateErrorInfo(proto) {
    var tmp0_safe_receiver = proto.constructor;
    var metadata = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.$metadata$;
    var tmp2_safe_receiver = metadata == null ? null : metadata.errorInfo;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp2_safe_receiver;
    }
    var result = 0;
    if (hasProp(proto, 'message'))
      result = result | 1;
    if (hasProp(proto, 'cause'))
      result = result | 2;
    if (!(result === 3)) {
      var parentProto = getPrototypeOf(proto);
      if (parentProto != Error.prototype) {
        result = result | calculateErrorInfo(parentProto);
      }
    }
    if (!(metadata == null)) {
      metadata.errorInfo = result;
    }
    return result;
  }
  function hasProp(proto, propName) {
    return proto.hasOwnProperty(propName);
  }
  function getPrototypeOf(obj) {
    return Object.getPrototypeOf(obj);
  }
  function get_VOID() {
    _init_properties_void_kt__3zg9as();
    return VOID;
  }
  var VOID;
  var properties_initialized_void_kt_e4ret2;
  function _init_properties_void_kt__3zg9as() {
    if (!properties_initialized_void_kt_e4ret2) {
      properties_initialized_void_kt_e4ret2 = true;
      VOID = void 0;
    }
  }
  function copyOf(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Int32Array(newSize));
  }
  function copyOf_0(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return arrayCopyResize(_this__u8e3s4, newSize, null);
  }
  function isNaN_0(_this__u8e3s4) {
    return !(_this__u8e3s4 === _this__u8e3s4);
  }
  function takeHighestOneBit(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === 0) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.countLeadingZeroBits' call
      tmp = 1 << (31 - clz32(_this__u8e3s4) | 0);
    }
    return tmp;
  }
  function Unit() {
  }
  protoOf(Unit).toString = function () {
    return 'kotlin.Unit';
  };
  var Unit_instance;
  function Unit_getInstance() {
    return Unit_instance;
  }
  function collectionToArray(collection) {
    return collectionToArrayCommonImpl(collection);
  }
  function mapOf(pair) {
    return hashMapOf([pair]);
  }
  function listOf(element) {
    return arrayListOf([element]);
  }
  function mapCapacity(expectedSize) {
    return expectedSize;
  }
  function copyToArray(collection) {
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (collection.toArray !== undefined) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = collection.toArray();
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = collectionToArray(collection);
    }
    return tmp;
  }
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  protoOf(AbstractMutableCollection).b1 = function () {
    this.p2();
    var iterator = this.c();
    while (iterator.d()) {
      iterator.e();
      iterator.q2();
    }
  };
  protoOf(AbstractMutableCollection).toJSON = function () {
    return this.toArray();
  };
  protoOf(AbstractMutableCollection).p2 = function () {
  };
  function IteratorImpl($outer) {
    this.t2_1 = $outer;
    this.r2_1 = 0;
    this.s2_1 = -1;
  }
  protoOf(IteratorImpl).d = function () {
    return this.r2_1 < this.t2_1.g();
  };
  protoOf(IteratorImpl).e = function () {
    if (!this.d())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.r2_1;
    this.r2_1 = _unary__edvuaz + 1 | 0;
    tmp.s2_1 = _unary__edvuaz;
    return this.t2_1.k(this.s2_1);
  };
  protoOf(IteratorImpl).q2 = function () {
    // Inline function 'kotlin.check' call
    if (!!(this.s2_1 === -1)) {
      var message = 'Call next() or previous() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.t2_1.v2(this.s2_1);
    this.r2_1 = this.s2_1;
    this.s2_1 = -1;
  };
  function ListIteratorImpl($outer, index) {
    this.z2_1 = $outer;
    IteratorImpl.call(this, $outer);
    Companion_instance_6.b3(index, this.z2_1.g());
    this.r2_1 = index;
  }
  protoOf(ListIteratorImpl).c3 = function () {
    return this.r2_1 > 0;
  };
  protoOf(ListIteratorImpl).d3 = function () {
    return this.r2_1;
  };
  protoOf(ListIteratorImpl).e3 = function () {
    if (!this.c3())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    this.r2_1 = this.r2_1 - 1 | 0;
    tmp.s2_1 = this.r2_1;
    return this.z2_1.k(this.s2_1);
  };
  function SubList(list, fromIndex, toIndex) {
    AbstractMutableList.call(this);
    this.g3_1 = list;
    this.h3_1 = fromIndex;
    this.i3_1 = 0;
    Companion_instance_6.j3(this.h3_1, toIndex, this.g3_1.g());
    this.i3_1 = toIndex - this.h3_1 | 0;
  }
  protoOf(SubList).k = function (index) {
    Companion_instance_6.k3(index, this.i3_1);
    return this.g3_1.k(this.h3_1 + index | 0);
  };
  protoOf(SubList).v2 = function (index) {
    Companion_instance_6.k3(index, this.i3_1);
    var result = this.g3_1.v2(this.h3_1 + index | 0);
    this.i3_1 = this.i3_1 - 1 | 0;
    return result;
  };
  protoOf(SubList).g = function () {
    return this.i3_1;
  };
  protoOf(SubList).p2 = function () {
    return this.g3_1.p2();
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this.u2_1 = 0;
  }
  protoOf(AbstractMutableList).c = function () {
    return new IteratorImpl(this);
  };
  protoOf(AbstractMutableList).i = function (element) {
    return this.l(element) >= 0;
  };
  protoOf(AbstractMutableList).l = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = this.c();
      while (_iterator__ex2g4s.d()) {
        var item = _iterator__ex2g4s.e();
        if (equals(item, element)) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractMutableList).m = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfLast' call
      var iterator = this.o(this.g());
      while (iterator.c3()) {
        var it = iterator.e3();
        if (equals(it, element)) {
          tmp$ret$1 = iterator.d3();
          break $l$block;
        }
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractMutableList).n = function () {
    return this.o(0);
  };
  protoOf(AbstractMutableList).o = function (index) {
    return new ListIteratorImpl(this, index);
  };
  protoOf(AbstractMutableList).p = function (fromIndex, toIndex) {
    return new SubList(this, fromIndex, toIndex);
  };
  protoOf(AbstractMutableList).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtList) : false))
      return false;
    return Companion_instance_6.l3(this, other);
  };
  protoOf(AbstractMutableList).hashCode = function () {
    return Companion_instance_6.m3(this);
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.p3_1 = null;
    this.q3_1 = null;
  }
  protoOf(AbstractMutableMap).r3 = function () {
    return new HashMapKeysDefault(this);
  };
  protoOf(AbstractMutableMap).s3 = function () {
    return new HashMapValuesDefault(this);
  };
  protoOf(AbstractMutableMap).v = function () {
    var tmp0_elvis_lhs = this.p3_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.r3();
      this.p3_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractMutableMap).w = function () {
    var tmp0_elvis_lhs = this.q3_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.s3();
      this.q3_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractMutableMap).b1 = function () {
    this.x().b1();
  };
  protoOf(AbstractMutableMap).a1 = function (from) {
    this.p2();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.x().c();
    while (_iterator__ex2g4s.d()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.e();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.q();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.r();
      this.y(key, value);
    }
  };
  protoOf(AbstractMutableMap).z = function (key) {
    this.p2();
    var iter = this.x().c();
    while (iter.d()) {
      var entry = iter.e();
      var k = entry.q();
      if (equals(key, k)) {
        var value = entry.r();
        iter.q2();
        return value;
      }
    }
    return null;
  };
  protoOf(AbstractMutableMap).p2 = function () {
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  protoOf(AbstractMutableSet).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtSet) : false))
      return false;
    return Companion_instance_8.w3(this, other);
  };
  protoOf(AbstractMutableSet).hashCode = function () {
    return Companion_instance_8.x3(this);
  };
  function arrayOfUninitializedElements(capacity) {
    // Inline function 'kotlin.require' call
    if (!(capacity >= 0)) {
      var message = 'capacity must be non-negative.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return Array(capacity);
  }
  function resetRange(_this__u8e3s4, fromIndex, toIndex) {
    // Inline function 'kotlin.js.nativeFill' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.fill(null, fromIndex, toIndex);
  }
  function copyOfUninitializedElements(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return copyOf_0(_this__u8e3s4, newSize);
  }
  function resetAt(_this__u8e3s4, index) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4[index] = null;
  }
  function Companion_4() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList_init_$Create$_0(0);
    this_0.b2_1 = true;
    tmp.y3_1 = this_0;
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function ArrayList_init_$Init$($this) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    ArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(objectCreate(protoOf(ArrayList)));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    ArrayList.call($this, tmp$ret$0);
    // Inline function 'kotlin.require' call
    if (!(initialCapacity >= 0)) {
      var message = 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, objectCreate(protoOf(ArrayList)));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(elements);
    ArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, objectCreate(protoOf(ArrayList)));
  }
  function rangeCheck($this, index) {
    // Inline function 'kotlin.apply' call
    Companion_instance_6.k3(index, $this.g());
    return index;
  }
  function ArrayList(array) {
    Companion_getInstance_4();
    AbstractMutableList.call(this);
    this.a2_1 = array;
    this.b2_1 = false;
  }
  protoOf(ArrayList).c2 = function () {
    this.p2();
    this.b2_1 = true;
    return this.g() > 0 ? this : Companion_getInstance_4().y3_1;
  };
  protoOf(ArrayList).g = function () {
    return this.a2_1.length;
  };
  protoOf(ArrayList).k = function (index) {
    var tmp = this.a2_1[rangeCheck(this, index)];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(ArrayList).v2 = function (index) {
    this.p2();
    rangeCheck(this, index);
    this.u2_1 = this.u2_1 + 1 | 0;
    var tmp;
    if (index === get_lastIndex(this)) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.a2_1.pop();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.a2_1.splice(index, 1)[0];
    }
    return tmp;
  };
  protoOf(ArrayList).l = function (element) {
    return indexOf(this.a2_1, element);
  };
  protoOf(ArrayList).m = function (element) {
    return lastIndexOf(this.a2_1, element);
  };
  protoOf(ArrayList).toString = function () {
    return arrayToString(this.a2_1);
  };
  protoOf(ArrayList).z3 = function () {
    return [].slice.call(this.a2_1);
  };
  protoOf(ArrayList).toArray = function () {
    return this.z3();
  };
  protoOf(ArrayList).p2 = function () {
    if (this.b2_1)
      throw UnsupportedOperationException_init_$Create$();
  };
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this.n2_1 = internalMap;
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(InternalHashMap_init_$Create$(), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(objectCreate(protoOf(HashMap)));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$(InternalHashMap_init_$Create$_2(initialCapacity, loadFactor), $this);
    return $this;
  }
  function HashMap_init_$Init$_2(initialCapacity, $this) {
    HashMap_init_$Init$_1(initialCapacity, 1.0, $this);
    return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity) {
    return HashMap_init_$Init$_2(initialCapacity, objectCreate(protoOf(HashMap)));
  }
  function HashMap_init_$Init$_3(original, $this) {
    HashMap_init_$Init$(InternalHashMap_init_$Create$_1(original), $this);
    return $this;
  }
  protoOf(HashMap).b1 = function () {
    this.n2_1.b1();
  };
  protoOf(HashMap).s = function (key) {
    return this.n2_1.a4(key);
  };
  protoOf(HashMap).t = function (value) {
    return this.n2_1.t(value);
  };
  protoOf(HashMap).r3 = function () {
    return new HashMapKeys(this.n2_1);
  };
  protoOf(HashMap).s3 = function () {
    return new HashMapValues(this.n2_1);
  };
  protoOf(HashMap).x = function () {
    var tmp0_elvis_lhs = this.o2_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new HashMapEntrySet(this.n2_1);
      this.o2_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(HashMap).u = function (key) {
    return this.n2_1.u(key);
  };
  protoOf(HashMap).y = function (key, value) {
    return this.n2_1.y(key, value);
  };
  protoOf(HashMap).z = function (key) {
    return this.n2_1.z(key);
  };
  protoOf(HashMap).g = function () {
    return this.n2_1.g();
  };
  protoOf(HashMap).a1 = function (from) {
    return this.n2_1.a1(from);
  };
  function HashMap() {
    this.o2_1 = null;
  }
  function HashMapKeys(backing) {
    AbstractMutableSet.call(this);
    this.b4_1 = backing;
  }
  protoOf(HashMapKeys).g = function () {
    return this.b4_1.g();
  };
  protoOf(HashMapKeys).h = function () {
    return this.b4_1.g() === 0;
  };
  protoOf(HashMapKeys).i = function (element) {
    return this.b4_1.a4(element);
  };
  protoOf(HashMapKeys).b1 = function () {
    return this.b4_1.b1();
  };
  protoOf(HashMapKeys).c = function () {
    return this.b4_1.c4();
  };
  protoOf(HashMapKeys).p2 = function () {
    return this.b4_1.d4();
  };
  function HashMapValues(backing) {
    AbstractMutableCollection.call(this);
    this.e4_1 = backing;
  }
  protoOf(HashMapValues).g = function () {
    return this.e4_1.g();
  };
  protoOf(HashMapValues).h = function () {
    return this.e4_1.g() === 0;
  };
  protoOf(HashMapValues).f4 = function (element) {
    return this.e4_1.t(element);
  };
  protoOf(HashMapValues).i = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.f4((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValues).c = function () {
    return this.e4_1.g4();
  };
  protoOf(HashMapValues).p2 = function () {
    return this.e4_1.d4();
  };
  function HashMapEntrySet(backing) {
    HashMapEntrySetBase.call(this, backing);
  }
  protoOf(HashMapEntrySet).c = function () {
    return this.i4_1.j4();
  };
  function HashMapEntrySetBase(backing) {
    AbstractMutableSet.call(this);
    this.i4_1 = backing;
  }
  protoOf(HashMapEntrySetBase).g = function () {
    return this.i4_1.g();
  };
  protoOf(HashMapEntrySetBase).h = function () {
    return this.i4_1.g() === 0;
  };
  protoOf(HashMapEntrySetBase).k4 = function (element) {
    return this.i4_1.l4(element);
  };
  protoOf(HashMapEntrySetBase).i = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.k4((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(HashMapEntrySetBase).b1 = function () {
    return this.i4_1.b1();
  };
  protoOf(HashMapEntrySetBase).j = function (elements) {
    return this.i4_1.m4(elements);
  };
  protoOf(HashMapEntrySetBase).p2 = function () {
    return this.i4_1.d4();
  };
  function HashMapKeysDefault$iterator$1($entryIterator) {
    this.n4_1 = $entryIterator;
  }
  protoOf(HashMapKeysDefault$iterator$1).d = function () {
    return this.n4_1.d();
  };
  protoOf(HashMapKeysDefault$iterator$1).e = function () {
    return this.n4_1.e().q();
  };
  protoOf(HashMapKeysDefault$iterator$1).q2 = function () {
    return this.n4_1.q2();
  };
  function HashMapKeysDefault(backingMap) {
    AbstractMutableSet.call(this);
    this.o4_1 = backingMap;
  }
  protoOf(HashMapKeysDefault).b1 = function () {
    return this.o4_1.b1();
  };
  protoOf(HashMapKeysDefault).a4 = function (element) {
    return this.o4_1.s(element);
  };
  protoOf(HashMapKeysDefault).i = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.a4((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapKeysDefault).c = function () {
    var entryIterator = this.o4_1.x().c();
    return new HashMapKeysDefault$iterator$1(entryIterator);
  };
  protoOf(HashMapKeysDefault).g = function () {
    return this.o4_1.g();
  };
  protoOf(HashMapKeysDefault).p2 = function () {
    return this.o4_1.p2();
  };
  function HashMapValuesDefault$iterator$1($entryIterator) {
    this.p4_1 = $entryIterator;
  }
  protoOf(HashMapValuesDefault$iterator$1).d = function () {
    return this.p4_1.d();
  };
  protoOf(HashMapValuesDefault$iterator$1).e = function () {
    return this.p4_1.e().r();
  };
  protoOf(HashMapValuesDefault$iterator$1).q2 = function () {
    return this.p4_1.q2();
  };
  function HashMapValuesDefault(backingMap) {
    AbstractMutableCollection.call(this);
    this.q4_1 = backingMap;
  }
  protoOf(HashMapValuesDefault).f4 = function (element) {
    return this.q4_1.t(element);
  };
  protoOf(HashMapValuesDefault).i = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.f4((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValuesDefault).c = function () {
    var entryIterator = this.q4_1.x().c();
    return new HashMapValuesDefault$iterator$1(entryIterator);
  };
  protoOf(HashMapValuesDefault).g = function () {
    return this.q4_1.g();
  };
  protoOf(HashMapValuesDefault).p2 = function () {
    return this.q4_1.p2();
  };
  function computeHashSize($this, capacity) {
    return takeHighestOneBit(imul(coerceAtLeast(capacity, 1), 3));
  }
  function computeShift($this, hashSize) {
    // Inline function 'kotlin.countLeadingZeroBits' call
    return clz32(hashSize) + 1 | 0;
  }
  function checkForComodification($this) {
    if (!($this.b5_1.y4_1 === $this.d5_1))
      throw ConcurrentModificationException_init_$Create$_0('The backing map has been modified after this entry was obtained.');
  }
  function InternalHashMap_init_$Init$($this) {
    InternalHashMap_init_$Init$_0(8, $this);
    return $this;
  }
  function InternalHashMap_init_$Create$() {
    return InternalHashMap_init_$Init$(objectCreate(protoOf(InternalHashMap)));
  }
  function InternalHashMap_init_$Init$_0(initialCapacity, $this) {
    InternalHashMap.call($this, arrayOfUninitializedElements(initialCapacity), null, new Int32Array(initialCapacity), new Int32Array(computeHashSize(Companion_instance_5, initialCapacity)), 2, 0);
    return $this;
  }
  function InternalHashMap_init_$Create$_0(initialCapacity) {
    return InternalHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(InternalHashMap)));
  }
  function InternalHashMap_init_$Init$_1(original, $this) {
    InternalHashMap_init_$Init$_0(original.g(), $this);
    $this.a1(original);
    return $this;
  }
  function InternalHashMap_init_$Create$_1(original) {
    return InternalHashMap_init_$Init$_1(original, objectCreate(protoOf(InternalHashMap)));
  }
  function InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, $this) {
    InternalHashMap_init_$Init$_0(initialCapacity, $this);
    // Inline function 'kotlin.require' call
    if (!(loadFactor > 0)) {
      var message = 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return $this;
  }
  function InternalHashMap_init_$Create$_2(initialCapacity, loadFactor) {
    return InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, objectCreate(protoOf(InternalHashMap)));
  }
  function _get_capacity__a9k9f3($this) {
    return $this.r4_1.length;
  }
  function _get_hashSize__tftcho($this) {
    return $this.u4_1.length;
  }
  function registerModification($this) {
    $this.y4_1 = $this.y4_1 + 1 | 0;
  }
  function ensureExtraCapacity($this, n) {
    if (shouldCompact($this, n)) {
      compact($this, true);
    } else {
      ensureCapacity($this, $this.w4_1 + n | 0);
    }
  }
  function shouldCompact($this, extraCapacity) {
    var spareCapacity = _get_capacity__a9k9f3($this) - $this.w4_1 | 0;
    var gaps = $this.w4_1 - $this.g() | 0;
    return spareCapacity < extraCapacity && (gaps + spareCapacity | 0) >= extraCapacity && gaps >= (_get_capacity__a9k9f3($this) / 4 | 0);
  }
  function ensureCapacity($this, minCapacity) {
    if (minCapacity < 0)
      throw RuntimeException_init_$Create$_0('too many elements');
    if (minCapacity > _get_capacity__a9k9f3($this)) {
      var newSize = Companion_instance_6.e5(_get_capacity__a9k9f3($this), minCapacity);
      $this.r4_1 = copyOfUninitializedElements($this.r4_1, newSize);
      var tmp = $this;
      var tmp0_safe_receiver = $this.s4_1;
      tmp.s4_1 = tmp0_safe_receiver == null ? null : copyOfUninitializedElements(tmp0_safe_receiver, newSize);
      $this.t4_1 = copyOf($this.t4_1, newSize);
      var newHashSize = computeHashSize(Companion_instance_5, newSize);
      if (newHashSize > _get_hashSize__tftcho($this)) {
        rehash($this, newHashSize);
      }
    }
  }
  function allocateValuesArray($this) {
    var curValuesArray = $this.s4_1;
    if (!(curValuesArray == null))
      return curValuesArray;
    var newValuesArray = arrayOfUninitializedElements(_get_capacity__a9k9f3($this));
    $this.s4_1 = newValuesArray;
    return newValuesArray;
  }
  function hash($this, key) {
    return key == null ? 0 : imul(hashCode(key), -1640531527) >>> $this.x4_1 | 0;
  }
  function compact($this, updateHashArray) {
    var i = 0;
    var j = 0;
    var valuesArray = $this.s4_1;
    while (i < $this.w4_1) {
      var hash = $this.t4_1[i];
      if (hash >= 0) {
        $this.r4_1[j] = $this.r4_1[i];
        if (!(valuesArray == null)) {
          valuesArray[j] = valuesArray[i];
        }
        if (updateHashArray) {
          $this.t4_1[j] = hash;
          $this.u4_1[hash] = j + 1 | 0;
        }
        j = j + 1 | 0;
      }
      i = i + 1 | 0;
    }
    resetRange($this.r4_1, j, $this.w4_1);
    if (valuesArray == null)
      null;
    else {
      resetRange(valuesArray, j, $this.w4_1);
    }
    $this.w4_1 = j;
  }
  function rehash($this, newHashSize) {
    registerModification($this);
    if ($this.w4_1 > $this.z4_1) {
      compact($this, false);
    }
    $this.u4_1 = new Int32Array(newHashSize);
    $this.x4_1 = computeShift(Companion_instance_5, newHashSize);
    var i = 0;
    while (i < $this.w4_1) {
      var _unary__edvuaz = i;
      i = _unary__edvuaz + 1 | 0;
      if (!putRehash($this, _unary__edvuaz)) {
        throw IllegalStateException_init_$Create$_0('This cannot happen with fixed magic multiplier and grow-only hash array. Have object hashCodes changed?');
      }
    }
  }
  function putRehash($this, i) {
    var hash_0 = hash($this, $this.r4_1[i]);
    var probesLeft = $this.v4_1;
    while (true) {
      var index = $this.u4_1[hash_0];
      if (index === 0) {
        $this.u4_1[hash_0] = i + 1 | 0;
        $this.t4_1[i] = hash_0;
        return true;
      }
      probesLeft = probesLeft - 1 | 0;
      if (probesLeft < 0)
        return false;
      var _unary__edvuaz = hash_0;
      hash_0 = _unary__edvuaz - 1 | 0;
      if (_unary__edvuaz === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    }
  }
  function findKey($this, key) {
    var hash_0 = hash($this, key);
    var probesLeft = $this.v4_1;
    while (true) {
      var index = $this.u4_1[hash_0];
      if (index === 0)
        return -1;
      if (index > 0 && equals($this.r4_1[index - 1 | 0], key))
        return index - 1 | 0;
      probesLeft = probesLeft - 1 | 0;
      if (probesLeft < 0)
        return -1;
      var _unary__edvuaz = hash_0;
      hash_0 = _unary__edvuaz - 1 | 0;
      if (_unary__edvuaz === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    }
  }
  function findValue($this, value) {
    var i = $this.w4_1;
    $l$loop: while (true) {
      i = i - 1 | 0;
      if (!(i >= 0)) {
        break $l$loop;
      }
      if ($this.t4_1[i] >= 0 && equals(ensureNotNull($this.s4_1)[i], value))
        return i;
    }
    return -1;
  }
  function addKey($this, key) {
    $this.d4();
    retry: while (true) {
      var hash_0 = hash($this, key);
      var tentativeMaxProbeDistance = coerceAtMost(imul($this.v4_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
      var probeDistance = 0;
      while (true) {
        var index = $this.u4_1[hash_0];
        if (index <= 0) {
          if ($this.w4_1 >= _get_capacity__a9k9f3($this)) {
            ensureExtraCapacity($this, 1);
            continue retry;
          }
          var _unary__edvuaz = $this.w4_1;
          $this.w4_1 = _unary__edvuaz + 1 | 0;
          var putIndex = _unary__edvuaz;
          $this.r4_1[putIndex] = key;
          $this.t4_1[putIndex] = hash_0;
          $this.u4_1[hash_0] = putIndex + 1 | 0;
          $this.z4_1 = $this.z4_1 + 1 | 0;
          registerModification($this);
          if (probeDistance > $this.v4_1)
            $this.v4_1 = probeDistance;
          return putIndex;
        }
        if (equals($this.r4_1[index - 1 | 0], key)) {
          return -index | 0;
        }
        probeDistance = probeDistance + 1 | 0;
        if (probeDistance > tentativeMaxProbeDistance) {
          rehash($this, imul(_get_hashSize__tftcho($this), 2));
          continue retry;
        }
        var _unary__edvuaz_0 = hash_0;
        hash_0 = _unary__edvuaz_0 - 1 | 0;
        if (_unary__edvuaz_0 === 0)
          hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
      }
    }
  }
  function removeEntryAt($this, index) {
    resetAt($this.r4_1, index);
    var tmp0_safe_receiver = $this.s4_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      resetAt(tmp0_safe_receiver, index);
    }
    removeHashAt($this, $this.t4_1[index]);
    $this.t4_1[index] = -1;
    $this.z4_1 = $this.z4_1 - 1 | 0;
    registerModification($this);
  }
  function removeHashAt($this, removedHash) {
    var hash_0 = removedHash;
    var hole = removedHash;
    var probeDistance = 0;
    var patchAttemptsLeft = coerceAtMost(imul($this.v4_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
    while (true) {
      var _unary__edvuaz = hash_0;
      hash_0 = _unary__edvuaz - 1 | 0;
      if (_unary__edvuaz === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
      probeDistance = probeDistance + 1 | 0;
      if (probeDistance > $this.v4_1) {
        $this.u4_1[hole] = 0;
        return Unit_instance;
      }
      var index = $this.u4_1[hash_0];
      if (index === 0) {
        $this.u4_1[hole] = 0;
        return Unit_instance;
      }
      if (index < 0) {
        $this.u4_1[hole] = -1;
        hole = hash_0;
        probeDistance = 0;
      } else {
        var otherHash = hash($this, $this.r4_1[index - 1 | 0]);
        if (((otherHash - hash_0 | 0) & (_get_hashSize__tftcho($this) - 1 | 0)) >= probeDistance) {
          $this.u4_1[hole] = index;
          $this.t4_1[index - 1 | 0] = hole;
          hole = hash_0;
          probeDistance = 0;
        }
      }
      patchAttemptsLeft = patchAttemptsLeft - 1 | 0;
      if (patchAttemptsLeft < 0) {
        $this.u4_1[hole] = -1;
        return Unit_instance;
      }
    }
  }
  function contentEquals($this, other) {
    return $this.z4_1 === other.g() && $this.m4(other.x());
  }
  function putEntry($this, entry) {
    var index = addKey($this, entry.q());
    var valuesArray = allocateValuesArray($this);
    if (index >= 0) {
      valuesArray[index] = entry.r();
      return true;
    }
    var oldValue = valuesArray[(-index | 0) - 1 | 0];
    if (!equals(entry.r(), oldValue)) {
      valuesArray[(-index | 0) - 1 | 0] = entry.r();
      return true;
    }
    return false;
  }
  function putAllEntries($this, from) {
    if (from.h())
      return false;
    ensureExtraCapacity($this, from.g());
    var it = from.c();
    var updated = false;
    while (it.d()) {
      if (putEntry($this, it.e()))
        updated = true;
    }
    return updated;
  }
  function Companion_5() {
    this.f5_1 = -1640531527;
    this.g5_1 = 8;
    this.h5_1 = 2;
    this.i5_1 = -1;
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function Itr(map) {
    this.j5_1 = map;
    this.k5_1 = 0;
    this.l5_1 = -1;
    this.m5_1 = this.j5_1.y4_1;
    this.n5();
  }
  protoOf(Itr).n5 = function () {
    while (this.k5_1 < this.j5_1.w4_1 && this.j5_1.t4_1[this.k5_1] < 0) {
      this.k5_1 = this.k5_1 + 1 | 0;
    }
  };
  protoOf(Itr).d = function () {
    return this.k5_1 < this.j5_1.w4_1;
  };
  protoOf(Itr).q2 = function () {
    this.o5();
    // Inline function 'kotlin.check' call
    if (!!(this.l5_1 === -1)) {
      var message = 'Call next() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.j5_1.d4();
    removeEntryAt(this.j5_1, this.l5_1);
    this.l5_1 = -1;
    this.m5_1 = this.j5_1.y4_1;
  };
  protoOf(Itr).o5 = function () {
    if (!(this.j5_1.y4_1 === this.m5_1))
      throw ConcurrentModificationException_init_$Create$();
  };
  function KeysItr(map) {
    Itr.call(this, map);
  }
  protoOf(KeysItr).e = function () {
    this.o5();
    if (this.k5_1 >= this.j5_1.w4_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.k5_1;
    this.k5_1 = _unary__edvuaz + 1 | 0;
    tmp.l5_1 = _unary__edvuaz;
    var result = this.j5_1.r4_1[this.l5_1];
    this.n5();
    return result;
  };
  function ValuesItr(map) {
    Itr.call(this, map);
  }
  protoOf(ValuesItr).e = function () {
    this.o5();
    if (this.k5_1 >= this.j5_1.w4_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.k5_1;
    this.k5_1 = _unary__edvuaz + 1 | 0;
    tmp.l5_1 = _unary__edvuaz;
    var result = ensureNotNull(this.j5_1.s4_1)[this.l5_1];
    this.n5();
    return result;
  };
  function EntriesItr(map) {
    Itr.call(this, map);
  }
  protoOf(EntriesItr).e = function () {
    this.o5();
    if (this.k5_1 >= this.j5_1.w4_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.k5_1;
    this.k5_1 = _unary__edvuaz + 1 | 0;
    tmp.l5_1 = _unary__edvuaz;
    var result = new EntryRef(this.j5_1, this.l5_1);
    this.n5();
    return result;
  };
  protoOf(EntriesItr).b6 = function () {
    if (this.k5_1 >= this.j5_1.w4_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.k5_1;
    this.k5_1 = _unary__edvuaz + 1 | 0;
    tmp.l5_1 = _unary__edvuaz;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.j5_1.r4_1[this.l5_1];
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = ensureNotNull(this.j5_1.s4_1)[this.l5_1];
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    var result = tmp_0 ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
    this.n5();
    return result;
  };
  protoOf(EntriesItr).c6 = function (sb) {
    if (this.k5_1 >= this.j5_1.w4_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.k5_1;
    this.k5_1 = _unary__edvuaz + 1 | 0;
    tmp.l5_1 = _unary__edvuaz;
    var key = this.j5_1.r4_1[this.l5_1];
    if (equals(key, this.j5_1))
      sb.f6('(this Map)');
    else
      sb.e6(key);
    sb.g6(_Char___init__impl__6a9atx(61));
    var value = ensureNotNull(this.j5_1.s4_1)[this.l5_1];
    if (equals(value, this.j5_1))
      sb.f6('(this Map)');
    else
      sb.e6(value);
    this.n5();
  };
  function EntryRef(map, index) {
    this.b5_1 = map;
    this.c5_1 = index;
    this.d5_1 = this.b5_1.y4_1;
  }
  protoOf(EntryRef).q = function () {
    checkForComodification(this);
    return this.b5_1.r4_1[this.c5_1];
  };
  protoOf(EntryRef).r = function () {
    checkForComodification(this);
    return ensureNotNull(this.b5_1.s4_1)[this.c5_1];
  };
  protoOf(EntryRef).equals = function (other) {
    var tmp;
    var tmp_0;
    if (!(other == null) ? isInterface(other, Entry) : false) {
      tmp_0 = equals(other.q(), this.q());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(other.r(), this.r());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EntryRef).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.q();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.r();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
  };
  protoOf(EntryRef).toString = function () {
    return toString_0(this.q()) + '=' + toString_0(this.r());
  };
  function InternalHashMap(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
    this.r4_1 = keysArray;
    this.s4_1 = valuesArray;
    this.t4_1 = presenceArray;
    this.u4_1 = hashArray;
    this.v4_1 = maxProbeDistance;
    this.w4_1 = length;
    this.x4_1 = computeShift(Companion_instance_5, _get_hashSize__tftcho(this));
    this.y4_1 = 0;
    this.z4_1 = 0;
    this.a5_1 = false;
  }
  protoOf(InternalHashMap).g = function () {
    return this.z4_1;
  };
  protoOf(InternalHashMap).h6 = function () {
    this.d4();
    this.a5_1 = true;
  };
  protoOf(InternalHashMap).t = function (value) {
    return findValue(this, value) >= 0;
  };
  protoOf(InternalHashMap).u = function (key) {
    var index = findKey(this, key);
    if (index < 0)
      return null;
    return ensureNotNull(this.s4_1)[index];
  };
  protoOf(InternalHashMap).a4 = function (key) {
    return findKey(this, key) >= 0;
  };
  protoOf(InternalHashMap).y = function (key, value) {
    var index = addKey(this, key);
    var valuesArray = allocateValuesArray(this);
    if (index < 0) {
      var oldValue = valuesArray[(-index | 0) - 1 | 0];
      valuesArray[(-index | 0) - 1 | 0] = value;
      return oldValue;
    } else {
      valuesArray[index] = value;
      return null;
    }
  };
  protoOf(InternalHashMap).a1 = function (from) {
    this.d4();
    putAllEntries(this, from.x());
  };
  protoOf(InternalHashMap).z = function (key) {
    this.d4();
    var index = findKey(this, key);
    if (index < 0)
      return null;
    var oldValue = ensureNotNull(this.s4_1)[index];
    removeEntryAt(this, index);
    return oldValue;
  };
  protoOf(InternalHashMap).b1 = function () {
    this.d4();
    var inductionVariable = 0;
    var last = this.w4_1 - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var hash = this.t4_1[i];
        if (hash >= 0) {
          this.u4_1[hash] = 0;
          this.t4_1[i] = -1;
        }
      }
       while (!(i === last));
    resetRange(this.r4_1, 0, this.w4_1);
    var tmp0_safe_receiver = this.s4_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      resetRange(tmp0_safe_receiver, 0, this.w4_1);
    }
    this.z4_1 = 0;
    this.w4_1 = 0;
    registerModification(this);
  };
  protoOf(InternalHashMap).equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      if (!(other == null) ? isInterface(other, KtMap) : false) {
        tmp_0 = contentEquals(this, other);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(InternalHashMap).hashCode = function () {
    var result = 0;
    var it = this.j4();
    while (it.d()) {
      result = result + it.b6() | 0;
    }
    return result;
  };
  protoOf(InternalHashMap).toString = function () {
    var sb = StringBuilder_init_$Create$(2 + imul(this.z4_1, 3) | 0);
    sb.f6('{');
    var i = 0;
    var it = this.j4();
    while (it.d()) {
      if (i > 0) {
        sb.f6(', ');
      }
      it.c6(sb);
      i = i + 1 | 0;
    }
    sb.f6('}');
    return sb.toString();
  };
  protoOf(InternalHashMap).d4 = function () {
    if (this.a5_1)
      throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(InternalHashMap).l4 = function (entry) {
    var index = findKey(this, entry.q());
    if (index < 0)
      return false;
    return equals(ensureNotNull(this.s4_1)[index], entry.r());
  };
  protoOf(InternalHashMap).i6 = function (entry) {
    return this.l4(isInterface(entry, Entry) ? entry : THROW_CCE());
  };
  protoOf(InternalHashMap).c4 = function () {
    return new KeysItr(this);
  };
  protoOf(InternalHashMap).g4 = function () {
    return new ValuesItr(this);
  };
  protoOf(InternalHashMap).j4 = function () {
    return new EntriesItr(this);
  };
  function InternalMap() {
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(objectCreate(protoOf(LinkedHashMap)));
  }
  function LinkedHashMap_init_$Init$_0(initialCapacity, $this) {
    HashMap_init_$Init$_2(initialCapacity, $this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_0(initialCapacity) {
    return LinkedHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(LinkedHashMap)));
  }
  function LinkedHashMap_init_$Init$_1(original, $this) {
    HashMap_init_$Init$_3(original, $this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_1(original) {
    return LinkedHashMap_init_$Init$_1(original, objectCreate(protoOf(LinkedHashMap)));
  }
  function LinkedHashMap_init_$Init$_2(internalMap, $this) {
    HashMap_init_$Init$(internalMap, $this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_2(internalMap) {
    return LinkedHashMap_init_$Init$_2(internalMap, objectCreate(protoOf(LinkedHashMap)));
  }
  function EmptyHolder() {
    EmptyHolder_instance = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = InternalHashMap_init_$Create$_0(0);
    this_0.h6();
    tmp.j6_1 = LinkedHashMap_init_$Create$_2(this_0);
  }
  var EmptyHolder_instance;
  function EmptyHolder_getInstance() {
    if (EmptyHolder_instance == null)
      new EmptyHolder();
    return EmptyHolder_instance;
  }
  protoOf(LinkedHashMap).c2 = function () {
    this.n2_1.h6();
    var tmp;
    if (this.g() > 0) {
      tmp = this;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = EmptyHolder_getInstance().j6_1;
    }
    return tmp;
  };
  protoOf(LinkedHashMap).p2 = function () {
    return this.n2_1.d4();
  };
  function LinkedHashMap() {
  }
  function Exception_init_$Init$($this) {
    extendThrowable($this);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$() {
    var tmp = Exception_init_$Init$(objectCreate(protoOf(Exception)));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$_0(message) {
    var tmp = Exception_init_$Init$_0(message, objectCreate(protoOf(Exception)));
    captureStack(tmp, Exception_init_$Create$_0);
    return tmp;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  function IllegalArgumentException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$() {
    var tmp = IllegalArgumentException_init_$Init$(objectCreate(protoOf(IllegalArgumentException)));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$_0(message) {
    var tmp = IllegalArgumentException_init_$Init$_0(message, objectCreate(protoOf(IllegalArgumentException)));
    captureStack(tmp, IllegalArgumentException_init_$Create$_0);
    return tmp;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  function IllegalStateException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$() {
    var tmp = IllegalStateException_init_$Init$(objectCreate(protoOf(IllegalStateException)));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message) {
    var tmp = IllegalStateException_init_$Init$_0(message, objectCreate(protoOf(IllegalStateException)));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(objectCreate(protoOf(UnsupportedOperationException)));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, objectCreate(protoOf(UnsupportedOperationException)));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$() {
    var tmp = RuntimeException_init_$Init$(objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$);
    return tmp;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_0(message) {
    var tmp = RuntimeException_init_$Init$_0(message, objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$_0);
    return tmp;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(objectCreate(protoOf(NoSuchElementException)));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, objectCreate(protoOf(NoSuchElementException)));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  function IndexOutOfBoundsException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$() {
    var tmp = IndexOutOfBoundsException_init_$Init$(objectCreate(protoOf(IndexOutOfBoundsException)));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$_0(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$_0(message, objectCreate(protoOf(IndexOutOfBoundsException)));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$_0);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  function ConcurrentModificationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ConcurrentModificationException.call($this);
    return $this;
  }
  function ConcurrentModificationException_init_$Create$() {
    var tmp = ConcurrentModificationException_init_$Init$(objectCreate(protoOf(ConcurrentModificationException)));
    captureStack(tmp, ConcurrentModificationException_init_$Create$);
    return tmp;
  }
  function ConcurrentModificationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ConcurrentModificationException.call($this);
    return $this;
  }
  function ConcurrentModificationException_init_$Create$_0(message) {
    var tmp = ConcurrentModificationException_init_$Init$_0(message, objectCreate(protoOf(ConcurrentModificationException)));
    captureStack(tmp, ConcurrentModificationException_init_$Create$_0);
    return tmp;
  }
  function ConcurrentModificationException() {
    captureStack(this, ConcurrentModificationException);
  }
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(objectCreate(protoOf(NullPointerException)));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(objectCreate(protoOf(ClassCastException)));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  function fillFrom(src, dst) {
    var srcLen = src.length;
    var dstLen = dst.length;
    var index = 0;
    // Inline function 'kotlin.js.unsafeCast' call
    var arr = dst;
    while (index < srcLen && index < dstLen) {
      var tmp = index;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      arr[tmp] = src[_unary__edvuaz];
    }
    return dst;
  }
  function arrayCopyResize(source, newSize, defaultValue) {
    // Inline function 'kotlin.js.unsafeCast' call
    var result = source.slice(0, newSize);
    // Inline function 'kotlin.copyArrayType' call
    if (source.$type$ !== undefined) {
      result.$type$ = source.$type$;
    }
    var index = source.length;
    if (newSize > index) {
      // Inline function 'kotlin.js.asDynamic' call
      result.length = newSize;
      while (index < newSize) {
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        result[_unary__edvuaz] = defaultValue;
      }
    }
    return result;
  }
  function KClass() {
  }
  function KClassImpl(jClass) {
    this.n6_1 = jClass;
  }
  protoOf(KClassImpl).o6 = function () {
    return this.n6_1;
  };
  protoOf(KClassImpl).equals = function (other) {
    var tmp;
    if (other instanceof NothingKClassImpl) {
      tmp = false;
    } else {
      if (other instanceof ErrorKClass) {
        tmp = false;
      } else {
        if (other instanceof KClassImpl) {
          tmp = equals(this.o6(), other.o6());
        } else {
          tmp = false;
        }
      }
    }
    return tmp;
  };
  protoOf(KClassImpl).hashCode = function () {
    var tmp0_safe_receiver = this.m6();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(KClassImpl).toString = function () {
    return 'class ' + this.m6();
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this.q6_1 = 'Nothing';
  }
  protoOf(NothingKClassImpl).m6 = function () {
    return this.q6_1;
  };
  protoOf(NothingKClassImpl).o6 = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  protoOf(NothingKClassImpl).equals = function (other) {
    return other === this;
  };
  protoOf(NothingKClassImpl).hashCode = function () {
    return 0;
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  protoOf(ErrorKClass).equals = function (other) {
    return other === this;
  };
  protoOf(ErrorKClass).hashCode = function () {
    return 0;
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this.s6_1 = givenSimpleName;
    this.t6_1 = isInstanceFunction;
  }
  protoOf(PrimitiveKClassImpl).equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    return protoOf(KClassImpl).equals.call(this, other) && this.s6_1 === other.s6_1;
  };
  protoOf(PrimitiveKClassImpl).m6 = function () {
    return this.s6_1;
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = jClass.$metadata$;
    // Inline function 'kotlin.js.unsafeCast' call
    tmp.v6_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
  }
  protoOf(SimpleKClassImpl).m6 = function () {
    return this.v6_1;
  };
  function get_functionClasses() {
    _init_properties_primitives_kt__3fums4();
    return functionClasses;
  }
  var functionClasses;
  function PrimitiveClasses$anyClass$lambda(it) {
    return !(it == null);
  }
  function PrimitiveClasses$numberClass$lambda(it) {
    return isNumber(it);
  }
  function PrimitiveClasses$booleanClass$lambda(it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  }
  function PrimitiveClasses$byteClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$shortClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$intClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$floatClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$doubleClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$arrayClass$lambda(it) {
    return !(it == null) ? isArray(it) : false;
  }
  function PrimitiveClasses$stringClass$lambda(it) {
    return !(it == null) ? typeof it === 'string' : false;
  }
  function PrimitiveClasses$throwableClass$lambda(it) {
    return it instanceof Error;
  }
  function PrimitiveClasses$booleanArrayClass$lambda(it) {
    return !(it == null) ? isBooleanArray(it) : false;
  }
  function PrimitiveClasses$charArrayClass$lambda(it) {
    return !(it == null) ? isCharArray(it) : false;
  }
  function PrimitiveClasses$byteArrayClass$lambda(it) {
    return !(it == null) ? isByteArray(it) : false;
  }
  function PrimitiveClasses$shortArrayClass$lambda(it) {
    return !(it == null) ? isShortArray(it) : false;
  }
  function PrimitiveClasses$intArrayClass$lambda(it) {
    return !(it == null) ? isIntArray(it) : false;
  }
  function PrimitiveClasses$longArrayClass$lambda(it) {
    return !(it == null) ? isLongArray(it) : false;
  }
  function PrimitiveClasses$floatArrayClass$lambda(it) {
    return !(it == null) ? isFloatArray(it) : false;
  }
  function PrimitiveClasses$doubleArrayClass$lambda(it) {
    return !(it == null) ? isDoubleArray(it) : false;
  }
  function PrimitiveClasses$functionClass$lambda($arity) {
    return function (it) {
      var tmp;
      if (typeof it === 'function') {
        // Inline function 'kotlin.js.asDynamic' call
        tmp = it.length === $arity;
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function PrimitiveClasses() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0 = Object;
    tmp.anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', PrimitiveClasses$anyClass$lambda);
    var tmp_1 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_2 = Number;
    tmp_1.numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', PrimitiveClasses$numberClass$lambda);
    this.nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_4 = Boolean;
    tmp_3.booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', PrimitiveClasses$booleanClass$lambda);
    var tmp_5 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_6 = Number;
    tmp_5.byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', PrimitiveClasses$byteClass$lambda);
    var tmp_7 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_8 = Number;
    tmp_7.shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', PrimitiveClasses$shortClass$lambda);
    var tmp_9 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_10 = Number;
    tmp_9.intClass = new PrimitiveKClassImpl(tmp_10, 'Int', PrimitiveClasses$intClass$lambda);
    var tmp_11 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_12 = Number;
    tmp_11.floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', PrimitiveClasses$floatClass$lambda);
    var tmp_13 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_14 = Number;
    tmp_13.doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', PrimitiveClasses$doubleClass$lambda);
    var tmp_15 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_16 = Array;
    tmp_15.arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', PrimitiveClasses$arrayClass$lambda);
    var tmp_17 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_18 = String;
    tmp_17.stringClass = new PrimitiveKClassImpl(tmp_18, 'String', PrimitiveClasses$stringClass$lambda);
    var tmp_19 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_20 = Error;
    tmp_19.throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', PrimitiveClasses$throwableClass$lambda);
    var tmp_21 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_22 = Array;
    tmp_21.booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', PrimitiveClasses$booleanArrayClass$lambda);
    var tmp_23 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_24 = Uint16Array;
    tmp_23.charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', PrimitiveClasses$charArrayClass$lambda);
    var tmp_25 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_26 = Int8Array;
    tmp_25.byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', PrimitiveClasses$byteArrayClass$lambda);
    var tmp_27 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_28 = Int16Array;
    tmp_27.shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', PrimitiveClasses$shortArrayClass$lambda);
    var tmp_29 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_30 = Int32Array;
    tmp_29.intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', PrimitiveClasses$intArrayClass$lambda);
    var tmp_31 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_32 = Array;
    tmp_31.longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', PrimitiveClasses$longArrayClass$lambda);
    var tmp_33 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_34 = Float32Array;
    tmp_33.floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', PrimitiveClasses$floatArrayClass$lambda);
    var tmp_35 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_36 = Float64Array;
    tmp_35.doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', PrimitiveClasses$doubleArrayClass$lambda);
  }
  protoOf(PrimitiveClasses).w6 = function () {
    return this.anyClass;
  };
  protoOf(PrimitiveClasses).x6 = function () {
    return this.numberClass;
  };
  protoOf(PrimitiveClasses).y6 = function () {
    return this.nothingClass;
  };
  protoOf(PrimitiveClasses).z6 = function () {
    return this.booleanClass;
  };
  protoOf(PrimitiveClasses).a7 = function () {
    return this.byteClass;
  };
  protoOf(PrimitiveClasses).b7 = function () {
    return this.shortClass;
  };
  protoOf(PrimitiveClasses).c7 = function () {
    return this.intClass;
  };
  protoOf(PrimitiveClasses).d7 = function () {
    return this.floatClass;
  };
  protoOf(PrimitiveClasses).e7 = function () {
    return this.doubleClass;
  };
  protoOf(PrimitiveClasses).f7 = function () {
    return this.arrayClass;
  };
  protoOf(PrimitiveClasses).g7 = function () {
    return this.stringClass;
  };
  protoOf(PrimitiveClasses).h7 = function () {
    return this.throwableClass;
  };
  protoOf(PrimitiveClasses).i7 = function () {
    return this.booleanArrayClass;
  };
  protoOf(PrimitiveClasses).j7 = function () {
    return this.charArrayClass;
  };
  protoOf(PrimitiveClasses).k7 = function () {
    return this.byteArrayClass;
  };
  protoOf(PrimitiveClasses).l7 = function () {
    return this.shortArrayClass;
  };
  protoOf(PrimitiveClasses).m7 = function () {
    return this.intArrayClass;
  };
  protoOf(PrimitiveClasses).n7 = function () {
    return this.longArrayClass;
  };
  protoOf(PrimitiveClasses).o7 = function () {
    return this.floatArrayClass;
  };
  protoOf(PrimitiveClasses).p7 = function () {
    return this.doubleArrayClass;
  };
  protoOf(PrimitiveClasses).functionClass = function (arity) {
    var tmp0_elvis_lhs = get_functionClasses()[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp_0 = Function;
      var tmp_1 = 'Function' + arity;
      var result = new PrimitiveKClassImpl(tmp_0, tmp_1, PrimitiveClasses$functionClass$lambda(arity));
      // Inline function 'kotlin.js.asDynamic' call
      get_functionClasses()[arity] = result;
      tmp = result;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses();
    return PrimitiveClasses_instance;
  }
  var properties_initialized_primitives_kt_jle18u;
  function _init_properties_primitives_kt__3fums4() {
    if (!properties_initialized_primitives_kt_jle18u) {
      properties_initialized_primitives_kt_jle18u = true;
      // Inline function 'kotlin.arrayOfNulls' call
      functionClasses = Array(0);
    }
  }
  function getKClass(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = getKClassM(jClass);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = getKClass1(jClass);
    }
    return tmp;
  }
  function getKClassM(jClasses) {
    var tmp;
    switch (jClasses.length) {
      case 1:
        tmp = getKClass1(jClasses[0]);
        break;
      case 0:
        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = NothingKClassImpl_getInstance();
        break;
      default:
        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = new ErrorKClass();
        break;
    }
    return tmp;
  }
  function getKClass1(jClass) {
    if (jClass === String) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      return PrimitiveClasses_getInstance().stringClass;
    }
    // Inline function 'kotlin.js.asDynamic' call
    var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function getKClassFromExpression(e) {
    var tmp;
    switch (typeof e) {
      case 'string':
        tmp = PrimitiveClasses_getInstance().stringClass;
        break;
      case 'number':
        var tmp_0;
        // Inline function 'kotlin.js.jsBitwiseOr' call

        // Inline function 'kotlin.js.asDynamic' call

        if ((e | 0) === e) {
          tmp_0 = PrimitiveClasses_getInstance().intClass;
        } else {
          tmp_0 = PrimitiveClasses_getInstance().doubleClass;
        }

        tmp = tmp_0;
        break;
      case 'boolean':
        tmp = PrimitiveClasses_getInstance().booleanClass;
        break;
      case 'function':
        var tmp_1 = PrimitiveClasses_getInstance();
        // Inline function 'kotlin.js.asDynamic' call

        tmp = tmp_1.functionClass(e.length);
        break;
      default:
        var tmp_2;
        if (isBooleanArray(e)) {
          tmp_2 = PrimitiveClasses_getInstance().booleanArrayClass;
        } else {
          if (isCharArray(e)) {
            tmp_2 = PrimitiveClasses_getInstance().charArrayClass;
          } else {
            if (isByteArray(e)) {
              tmp_2 = PrimitiveClasses_getInstance().byteArrayClass;
            } else {
              if (isShortArray(e)) {
                tmp_2 = PrimitiveClasses_getInstance().shortArrayClass;
              } else {
                if (isIntArray(e)) {
                  tmp_2 = PrimitiveClasses_getInstance().intArrayClass;
                } else {
                  if (isLongArray(e)) {
                    tmp_2 = PrimitiveClasses_getInstance().longArrayClass;
                  } else {
                    if (isFloatArray(e)) {
                      tmp_2 = PrimitiveClasses_getInstance().floatArrayClass;
                    } else {
                      if (isDoubleArray(e)) {
                        tmp_2 = PrimitiveClasses_getInstance().doubleArrayClass;
                      } else {
                        if (isInterface(e, KClass)) {
                          tmp_2 = getKClass(KClass);
                        } else {
                          if (isArray(e)) {
                            tmp_2 = PrimitiveClasses_getInstance().arrayClass;
                          } else {
                            var constructor = Object.getPrototypeOf(e).constructor;
                            var tmp_3;
                            if (constructor === Object) {
                              tmp_3 = PrimitiveClasses_getInstance().anyClass;
                            } else if (constructor === Error) {
                              tmp_3 = PrimitiveClasses_getInstance().throwableClass;
                            } else {
                              var jsClass = constructor;
                              tmp_3 = getKClass1(jsClass);
                            }
                            tmp_2 = tmp_3;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        tmp = tmp_2;
        break;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp;
  }
  function StringBuilder_init_$Init$(capacity, $this) {
    StringBuilder_init_$Init$_0($this);
    return $this;
  }
  function StringBuilder_init_$Create$(capacity) {
    return StringBuilder_init_$Init$(capacity, objectCreate(protoOf(StringBuilder)));
  }
  function StringBuilder_init_$Init$_0($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$_0() {
    return StringBuilder_init_$Init$_0(objectCreate(protoOf(StringBuilder)));
  }
  function StringBuilder(content) {
    this.d6_1 = content;
  }
  protoOf(StringBuilder).g6 = function (value) {
    this.d6_1 = this.d6_1 + toString(value);
    return this;
  };
  protoOf(StringBuilder).a = function (value) {
    this.d6_1 = this.d6_1 + toString_0(value);
    return this;
  };
  protoOf(StringBuilder).e6 = function (value) {
    this.d6_1 = this.d6_1 + toString_0(value);
    return this;
  };
  protoOf(StringBuilder).f6 = function (value) {
    var tmp = this;
    var tmp_0 = this.d6_1;
    tmp.d6_1 = tmp_0 + (value == null ? 'null' : value);
    return this;
  };
  protoOf(StringBuilder).toString = function () {
    return this.d6_1;
  };
  function AbstractCollection$toString$lambda(this$0) {
    return function (it) {
      return it === this$0 ? '(this Collection)' : toString_0(it);
    };
  }
  function AbstractCollection() {
  }
  protoOf(AbstractCollection).i = function (element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.h();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = this.c();
      while (_iterator__ex2g4s.d()) {
        var element_0 = _iterator__ex2g4s.e();
        if (equals(element_0, element)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractCollection).j = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.h();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.c();
      while (_iterator__ex2g4s.d()) {
        var element = _iterator__ex2g4s.e();
        if (!this.i(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractCollection).h = function () {
    return this.g() === 0;
  };
  protoOf(AbstractCollection).toString = function () {
    return joinToString_0(this, ', ', '[', ']', VOID, VOID, AbstractCollection$toString$lambda(this));
  };
  protoOf(AbstractCollection).toArray = function () {
    return collectionToArray(this);
  };
  function Companion_6() {
    this.a3_1 = 2147483639;
  }
  protoOf(Companion_6).k3 = function (index, size) {
    if (index < 0 || index >= size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(Companion_6).b3 = function (index, size) {
    if (index < 0 || index > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(Companion_6).j3 = function (fromIndex, toIndex, size) {
    if (fromIndex < 0 || toIndex > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
    }
    if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$_0('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }
  };
  protoOf(Companion_6).e5 = function (oldCapacity, minCapacity) {
    var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
    if ((newCapacity - minCapacity | 0) < 0)
      newCapacity = minCapacity;
    if ((newCapacity - 2147483639 | 0) > 0)
      newCapacity = minCapacity > 2147483639 ? 2147483647 : 2147483639;
    return newCapacity;
  };
  protoOf(Companion_6).m3 = function (c) {
    var hashCode_0 = 1;
    var _iterator__ex2g4s = c.c();
    while (_iterator__ex2g4s.d()) {
      var e = _iterator__ex2g4s.e();
      var tmp = imul(31, hashCode_0);
      var tmp1_elvis_lhs = e == null ? null : hashCode(e);
      hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    return hashCode_0;
  };
  protoOf(Companion_6).l3 = function (c, other) {
    if (!(c.g() === other.g()))
      return false;
    var otherIterator = other.c();
    var _iterator__ex2g4s = c.c();
    while (_iterator__ex2g4s.d()) {
      var elem = _iterator__ex2g4s.e();
      var elemOther = otherIterator.e();
      if (!equals(elem, elemOther)) {
        return false;
      }
    }
    return true;
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function AbstractMap$keys$1$iterator$1($entryIterator) {
    this.q7_1 = $entryIterator;
  }
  protoOf(AbstractMap$keys$1$iterator$1).d = function () {
    return this.q7_1.d();
  };
  protoOf(AbstractMap$keys$1$iterator$1).e = function () {
    return this.q7_1.e().q();
  };
  function AbstractMap$values$1$iterator$1($entryIterator) {
    this.r7_1 = $entryIterator;
  }
  protoOf(AbstractMap$values$1$iterator$1).d = function () {
    return this.r7_1.d();
  };
  protoOf(AbstractMap$values$1$iterator$1).e = function () {
    return this.r7_1.e().r();
  };
  function toString_2($this, entry) {
    return toString_3($this, entry.q()) + '=' + toString_3($this, entry.r());
  }
  function toString_3($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp0 = $this.x();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.c();
      while (_iterator__ex2g4s.d()) {
        var element = _iterator__ex2g4s.e();
        if (equals(element.q(), key)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function AbstractMap$keys$1(this$0) {
    this.s7_1 = this$0;
    AbstractSet.call(this);
  }
  protoOf(AbstractMap$keys$1).a4 = function (element) {
    return this.s7_1.s(element);
  };
  protoOf(AbstractMap$keys$1).i = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.a4((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractMap$keys$1).c = function () {
    var entryIterator = this.s7_1.x().c();
    return new AbstractMap$keys$1$iterator$1(entryIterator);
  };
  protoOf(AbstractMap$keys$1).g = function () {
    return this.s7_1.g();
  };
  function AbstractMap$toString$lambda(this$0) {
    return function (it) {
      return toString_2(this$0, it);
    };
  }
  function AbstractMap$values$1(this$0) {
    this.t7_1 = this$0;
    AbstractCollection.call(this);
  }
  protoOf(AbstractMap$values$1).f4 = function (element) {
    return this.t7_1.t(element);
  };
  protoOf(AbstractMap$values$1).i = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.f4((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractMap$values$1).c = function () {
    var entryIterator = this.t7_1.x().c();
    return new AbstractMap$values$1$iterator$1(entryIterator);
  };
  protoOf(AbstractMap$values$1).g = function () {
    return this.t7_1.g();
  };
  function AbstractMap() {
    this.t3_1 = null;
    this.u3_1 = null;
  }
  protoOf(AbstractMap).s = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  protoOf(AbstractMap).t = function (value) {
    var tmp0 = this.x();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.h();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.c();
      while (_iterator__ex2g4s.d()) {
        var element = _iterator__ex2g4s.e();
        if (equals(element.r(), value)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractMap).v3 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    var key = entry.q();
    var value = entry.r();
    // Inline function 'kotlin.collections.get' call
    var ourValue = (isInterface(this, KtMap) ? this : THROW_CCE()).u(key);
    if (!equals(value, ourValue)) {
      return false;
    }
    var tmp;
    if (ourValue == null) {
      // Inline function 'kotlin.collections.containsKey' call
      tmp = !(isInterface(this, KtMap) ? this : THROW_CCE()).s(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    }
    return true;
  };
  protoOf(AbstractMap).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtMap) : false))
      return false;
    if (!(this.g() === other.g()))
      return false;
    var tmp0 = other.x();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.h();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.c();
      while (_iterator__ex2g4s.d()) {
        var element = _iterator__ex2g4s.e();
        if (!this.v3(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractMap).u = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r();
  };
  protoOf(AbstractMap).hashCode = function () {
    return hashCode(this.x());
  };
  protoOf(AbstractMap).h = function () {
    return this.g() === 0;
  };
  protoOf(AbstractMap).g = function () {
    return this.x().g();
  };
  protoOf(AbstractMap).v = function () {
    if (this.t3_1 == null) {
      var tmp = this;
      tmp.t3_1 = new AbstractMap$keys$1(this);
    }
    return ensureNotNull(this.t3_1);
  };
  protoOf(AbstractMap).toString = function () {
    var tmp = this.x();
    return joinToString_0(tmp, ', ', '{', '}', VOID, VOID, AbstractMap$toString$lambda(this));
  };
  protoOf(AbstractMap).w = function () {
    if (this.u3_1 == null) {
      var tmp = this;
      tmp.u3_1 = new AbstractMap$values$1(this);
    }
    return ensureNotNull(this.u3_1);
  };
  function Companion_8() {
  }
  protoOf(Companion_8).x3 = function (c) {
    var hashCode_0 = 0;
    var _iterator__ex2g4s = c.c();
    while (_iterator__ex2g4s.d()) {
      var element = _iterator__ex2g4s.e();
      var tmp = hashCode_0;
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    return hashCode_0;
  };
  protoOf(Companion_8).w3 = function (c, other) {
    if (!(c.g() === other.g()))
      return false;
    return c.j(other);
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function AbstractSet() {
    AbstractCollection.call(this);
  }
  protoOf(AbstractSet).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtSet) : false))
      return false;
    return Companion_instance_8.w3(this, other);
  };
  protoOf(AbstractSet).hashCode = function () {
    return Companion_instance_8.x3(this);
  };
  function collectionToArrayCommonImpl(collection) {
    if (collection.h()) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    }
    // Inline function 'kotlin.arrayOfNulls' call
    var size = collection.g();
    var destination = Array(size);
    var iterator = collection.c();
    var index = 0;
    while (iterator.d()) {
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      destination[_unary__edvuaz] = iterator.e();
    }
    return destination;
  }
  function EmptyList() {
    EmptyList_instance = this;
    this.u7_1 = new Long(-1478467534, -1720727600);
  }
  protoOf(EmptyList).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, KtList) : false) {
      tmp = other.h();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EmptyList).hashCode = function () {
    return 1;
  };
  protoOf(EmptyList).toString = function () {
    return '[]';
  };
  protoOf(EmptyList).g = function () {
    return 0;
  };
  protoOf(EmptyList).h = function () {
    return true;
  };
  protoOf(EmptyList).v7 = function (element) {
    return false;
  };
  protoOf(EmptyList).i = function (element) {
    if (!false)
      return false;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.v7(tmp);
  };
  protoOf(EmptyList).w7 = function (elements) {
    return elements.h();
  };
  protoOf(EmptyList).j = function (elements) {
    return this.w7(elements);
  };
  protoOf(EmptyList).k = function (index) {
    throw IndexOutOfBoundsException_init_$Create$_0("Empty list doesn't contain element at index " + index + '.');
  };
  protoOf(EmptyList).x7 = function (element) {
    return -1;
  };
  protoOf(EmptyList).l = function (element) {
    if (!false)
      return -1;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.x7(tmp);
  };
  protoOf(EmptyList).y7 = function (element) {
    return -1;
  };
  protoOf(EmptyList).m = function (element) {
    if (!false)
      return -1;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.y7(tmp);
  };
  protoOf(EmptyList).c = function () {
    return EmptyIterator_instance;
  };
  protoOf(EmptyList).n = function () {
    return EmptyIterator_instance;
  };
  protoOf(EmptyList).o = function (index) {
    if (!(index === 0))
      throw IndexOutOfBoundsException_init_$Create$_0('Index: ' + index);
    return EmptyIterator_instance;
  };
  protoOf(EmptyList).p = function (fromIndex, toIndex) {
    if (fromIndex === 0 && toIndex === 0)
      return this;
    throw IndexOutOfBoundsException_init_$Create$_0('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex);
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function EmptyIterator() {
  }
  protoOf(EmptyIterator).d = function () {
    return false;
  };
  protoOf(EmptyIterator).c3 = function () {
    return false;
  };
  protoOf(EmptyIterator).d3 = function () {
    return 0;
  };
  protoOf(EmptyIterator).e = function () {
    throw NoSuchElementException_init_$Create$();
  };
  protoOf(EmptyIterator).e3 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    return EmptyIterator_instance;
  }
  function ArrayAsCollection(values, isVarargs) {
    this.z7_1 = values;
    this.a8_1 = isVarargs;
  }
  protoOf(ArrayAsCollection).g = function () {
    return this.z7_1.length;
  };
  protoOf(ArrayAsCollection).h = function () {
    // Inline function 'kotlin.collections.isEmpty' call
    return this.z7_1.length === 0;
  };
  protoOf(ArrayAsCollection).c = function () {
    return arrayIterator(this.z7_1);
  };
  function get_lastIndex(_this__u8e3s4) {
    return _this__u8e3s4.g() - 1 | 0;
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function asCollection(_this__u8e3s4) {
    return new ArrayAsCollection(_this__u8e3s4, false);
  }
  function mapOf_0(pairs) {
    return pairs.length > 0 ? toMap(pairs, LinkedHashMap_init_$Create$_0(mapCapacity(pairs.length))) : emptyMap();
  }
  function plus(_this__u8e3s4, map) {
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$_1(_this__u8e3s4);
    this_0.a1(map);
    return this_0;
  }
  function emptyMap() {
    var tmp = EmptyMap_getInstance();
    return isInterface(tmp, KtMap) ? tmp : THROW_CCE();
  }
  function toMap(_this__u8e3s4, destination) {
    // Inline function 'kotlin.apply' call
    putAll(destination, _this__u8e3s4);
    return destination;
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    this.b8_1 = new Long(-888910638, 1920087921);
  }
  protoOf(EmptyMap).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, KtMap) : false) {
      tmp = other.h();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EmptyMap).hashCode = function () {
    return 0;
  };
  protoOf(EmptyMap).toString = function () {
    return '{}';
  };
  protoOf(EmptyMap).g = function () {
    return 0;
  };
  protoOf(EmptyMap).h = function () {
    return true;
  };
  protoOf(EmptyMap).c8 = function (key) {
    return false;
  };
  protoOf(EmptyMap).s = function (key) {
    if (!(key == null ? true : !(key == null)))
      return false;
    return this.c8((key == null ? true : !(key == null)) ? key : THROW_CCE());
  };
  protoOf(EmptyMap).d8 = function (value) {
    return false;
  };
  protoOf(EmptyMap).t = function (value) {
    if (!false)
      return false;
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.d8(tmp);
  };
  protoOf(EmptyMap).e8 = function (key) {
    return null;
  };
  protoOf(EmptyMap).u = function (key) {
    if (!(key == null ? true : !(key == null)))
      return null;
    return this.e8((key == null ? true : !(key == null)) ? key : THROW_CCE());
  };
  protoOf(EmptyMap).x = function () {
    return EmptySet_getInstance();
  };
  protoOf(EmptyMap).v = function () {
    return EmptySet_getInstance();
  };
  protoOf(EmptyMap).w = function () {
    return EmptyList_getInstance();
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function putAll(_this__u8e3s4, pairs) {
    var inductionVariable = 0;
    var last = pairs.length;
    while (inductionVariable < last) {
      var _destruct__k2r9zo = pairs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = _destruct__k2r9zo.h8();
      var value = _destruct__k2r9zo.i8();
      _this__u8e3s4.y(key, value);
    }
  }
  function hashMapOf(pairs) {
    // Inline function 'kotlin.apply' call
    var this_0 = HashMap_init_$Create$_0(mapCapacity(pairs.length));
    putAll(this_0, pairs);
    return this_0;
  }
  function toMap_0(_this__u8e3s4) {
    return optimizeReadOnlyMap(toMap_1(_this__u8e3s4, LinkedHashMap_init_$Create$()));
  }
  function optimizeReadOnlyMap(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.g()) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        // Inline function 'kotlin.collections.toSingletonMapOrSelf' call

        tmp = _this__u8e3s4;
        break;
      default:
        tmp = _this__u8e3s4;
        break;
    }
    return tmp;
  }
  function toMap_1(_this__u8e3s4, destination) {
    // Inline function 'kotlin.apply' call
    putAll_0(destination, _this__u8e3s4);
    return destination;
  }
  function putAll_0(_this__u8e3s4, pairs) {
    var _iterator__ex2g4s = pairs.c();
    while (_iterator__ex2g4s.d()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.e();
      var key = _destruct__k2r9zo.h8();
      var value = _destruct__k2r9zo.i8();
      _this__u8e3s4.y(key, value);
    }
  }
  function sequenceOf(elements) {
    return asSequence(elements);
  }
  function ensureItemIterator($this) {
    var itemIterator = $this.k8_1;
    if (!(itemIterator == null) && itemIterator.d()) {
      $this.l8_1 = 1;
      return true;
    }
    while ($this.j8_1.d()) {
      var element = $this.j8_1.e();
      var nextItemIterator = $this.m8_1.p8_1($this.m8_1.o8_1(element));
      if (nextItemIterator.d()) {
        $this.k8_1 = nextItemIterator;
        $this.l8_1 = 1;
        return true;
      }
    }
    $this.l8_1 = 2;
    $this.k8_1 = null;
    return false;
  }
  function FlatteningSequence$iterator$1(this$0) {
    this.m8_1 = this$0;
    this.j8_1 = this$0.n8_1.c();
    this.k8_1 = null;
    this.l8_1 = 0;
  }
  protoOf(FlatteningSequence$iterator$1).e = function () {
    if (this.l8_1 === 2)
      throw NoSuchElementException_init_$Create$();
    if (this.l8_1 === 0 && !ensureItemIterator(this)) {
      throw NoSuchElementException_init_$Create$();
    }
    this.l8_1 = 0;
    return ensureNotNull(this.k8_1).e();
  };
  protoOf(FlatteningSequence$iterator$1).d = function () {
    if (this.l8_1 === 1)
      return true;
    if (this.l8_1 === 2)
      return false;
    return ensureItemIterator(this);
  };
  function FlatteningSequence(sequence, transformer, iterator) {
    this.n8_1 = sequence;
    this.o8_1 = transformer;
    this.p8_1 = iterator;
  }
  protoOf(FlatteningSequence).c = function () {
    return new FlatteningSequence$iterator$1(this);
  };
  function TransformingSequence$iterator$1(this$0) {
    this.r8_1 = this$0;
    this.q8_1 = this$0.s8_1.c();
  }
  protoOf(TransformingSequence$iterator$1).e = function () {
    return this.r8_1.t8_1(this.q8_1.e());
  };
  protoOf(TransformingSequence$iterator$1).d = function () {
    return this.q8_1.d();
  };
  function TransformingSequence(sequence, transformer) {
    this.s8_1 = sequence;
    this.t8_1 = transformer;
  }
  protoOf(TransformingSequence).c = function () {
    return new TransformingSequence$iterator$1(this);
  };
  function emptySequence() {
    return EmptySequence_instance;
  }
  function EmptySequence() {
  }
  protoOf(EmptySequence).c = function () {
    return EmptyIterator_instance;
  };
  var EmptySequence_instance;
  function EmptySequence_getInstance() {
    return EmptySequence_instance;
  }
  function EmptySet() {
    EmptySet_instance = this;
    this.u8_1 = new Long(1993859828, 793161749);
  }
  protoOf(EmptySet).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, KtSet) : false) {
      tmp = other.h();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EmptySet).hashCode = function () {
    return 0;
  };
  protoOf(EmptySet).toString = function () {
    return '[]';
  };
  protoOf(EmptySet).g = function () {
    return 0;
  };
  protoOf(EmptySet).h = function () {
    return true;
  };
  protoOf(EmptySet).w7 = function (elements) {
    return elements.h();
  };
  protoOf(EmptySet).j = function (elements) {
    return this.w7(elements);
  };
  protoOf(EmptySet).c = function () {
    return EmptyIterator_instance;
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function appendElement(_this__u8e3s4, element, transform) {
    if (!(transform == null))
      _this__u8e3s4.a(transform(element));
    else {
      if (element == null ? true : isCharSequence(element))
        _this__u8e3s4.a(element);
      else {
        if (element instanceof Char)
          _this__u8e3s4.g6(element.v8_1);
        else {
          _this__u8e3s4.a(toString_1(element));
        }
      }
    }
  }
  function Pair(first, second) {
    this.f8_1 = first;
    this.g8_1 = second;
  }
  protoOf(Pair).toString = function () {
    return '(' + toString_0(this.f8_1) + ', ' + toString_0(this.g8_1) + ')';
  };
  protoOf(Pair).h8 = function () {
    return this.f8_1;
  };
  protoOf(Pair).i8 = function () {
    return this.g8_1;
  };
  protoOf(Pair).hashCode = function () {
    var result = this.f8_1 == null ? 0 : hashCode(this.f8_1);
    result = imul(result, 31) + (this.g8_1 == null ? 0 : hashCode(this.g8_1)) | 0;
    return result;
  };
  protoOf(Pair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals(this.f8_1, tmp0_other_with_cast.f8_1))
      return false;
    if (!equals(this.g8_1, tmp0_other_with_cast.g8_1))
      return false;
    return true;
  };
  function to(_this__u8e3s4, that) {
    return new Pair(_this__u8e3s4, that);
  }
  //region block: post-declaration
  protoOf(AbstractMutableList).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(AbstractMap).asJsReadonlyMapView = asJsReadonlyMapView;
  protoOf(AbstractMutableMap).asJsMapView = asJsMapView;
  protoOf(InternalHashMap).m4 = containsAllEntries;
  protoOf(EmptyList).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(EmptyMap).asJsReadonlyMapView = asJsReadonlyMapView;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Unit_instance = new Unit();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  EmptyIterator_instance = new EmptyIterator();
  EmptySequence_instance = new EmptySequence();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $kotlin = _.kotlin || (_.kotlin = {});
    var $kotlin$collections = $kotlin.collections || ($kotlin.collections = {});
    defineProp($kotlin$collections, 'KtList', Companion_getInstance);
    defineProp($kotlin$collections, 'KtMap', Companion_getInstance_0);
    defineProp($kotlin$collections, 'KtMutableMap', Companion_getInstance_1);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = getKClassFromExpression;
  _.$_$.b = VOID;
  _.$_$.c = LinkedHashMap_init_$Create$_0;
  _.$_$.d = LinkedHashMap_init_$Create$;
  _.$_$.e = IllegalStateException_init_$Create$_0;
  _.$_$.f = Unit_instance;
  _.$_$.g = Iterable;
  _.$_$.h = KtMap;
  _.$_$.i = KtMutableMap;
  _.$_$.j = asSequence_0;
  _.$_$.k = emptyMap;
  _.$_$.l = listOf;
  _.$_$.m = mapCapacity;
  _.$_$.n = mapOf;
  _.$_$.o = mapOf_0;
  _.$_$.p = plus;
  _.$_$.q = toList;
  _.$_$.r = toMap_0;
  _.$_$.s = compareTo;
  _.$_$.t = defineProp;
  _.$_$.u = equals;
  _.$_$.v = getBooleanHashCode;
  _.$_$.w = getNumberHashCode;
  _.$_$.x = getStringHashCode;
  _.$_$.y = initMetadataForClass;
  _.$_$.z = initMetadataForCompanion;
  _.$_$.a1 = initMetadataForInterface;
  _.$_$.b1 = initMetadataForObject;
  _.$_$.c1 = isArray;
  _.$_$.d1 = isCharSequence;
  _.$_$.e1 = isInterface;
  _.$_$.f1 = isNumber;
  _.$_$.g1 = numberToDouble;
  _.$_$.h1 = numberToLong;
  _.$_$.i1 = objectCreate;
  _.$_$.j1 = protoOf;
  _.$_$.k1 = toLong;
  _.$_$.l1 = toString_1;
  _.$_$.m1 = coerceAtLeast;
  _.$_$.n1 = flatMap;
  _.$_$.o1 = map;
  _.$_$.p1 = sequenceOf;
  _.$_$.q1 = StringBuilder;
  _.$_$.r1 = Enum;
  _.$_$.s1 = Long;
  _.$_$.t1 = THROW_CCE;
  _.$_$.u1 = THROW_IAE;
  _.$_$.v1 = toString_0;
  _.$_$.w1 = to;
  //endregion
  return _;
}(module.exports));

//# sourceMappingURL=kotlin-kotlin-stdlib.js.map
